"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        const MIN_RESULTS_FOR_SEARCH = '10';
        function getDatasetRefName(datasetRef) {
            var _a, _b;
            return ((_a = dashboards.designer.getDatasets().find(t => t.id === datasetRef.id)) === null || _a === void 0 ? void 0 : _a.name)
                || ((_b = dashboards.designer.getRestrictedDatasets().find(t => t.id === datasetRef.id)) === null || _b === void 0 ? void 0 : _b.name)
                || '';
        }
        class DataQueryEditorBase extends distill.EditorBase {
            init() {
            }
            getDataQuery() {
                var _a;
                if (this.propDef.config && this.propDef.config.dataQuery)
                    return this.component[this.propDef.config.dataQuery];
                const rootPropName = ((_a = this.propDef.path) === null || _a === void 0 ? void 0 : _a.split('.')[0]) || this.propName;
                return this.component[rootPropName];
            }
        }
        dashboards.DataQueryEditorBase = DataQueryEditorBase;
        class DatasetLinkEditor {
            constructor(container) {
                this.context = null;
                this.isFirstLink = false;
                this.$datasetLinkRow = appn.utils.cloneTemplate('editor-datasetSelectorLinkRow');
                container.append(this.$datasetLinkRow);
                this.$linkedDatasetAlias = this.$datasetLinkRow.find('.linkedDatasetAlias');
                this.$linkedDataset = this.$datasetLinkRow.find('.linkedDatasetSelect');
                this.$linkedColumn = this.$datasetLinkRow.find('.linkedColumnSelect');
                this.$primaryDataset = this.$datasetLinkRow.find('.primaryDatasetSelect');
                this.$primaryColumn = this.$datasetLinkRow.find('.primaryColumnSelect');
                this.$linkedColumnContainer = this.$datasetLinkRow.find('.linkedColumnContainer');
                this.$primaryColumnContainer = this.$datasetLinkRow.find('.primaryColumnContainer');
                this.bindEvents();
            }
            update(context, isFirstLink = false) {
                this.context = context;
                this.isFirstLink = isFirstLink;
                const datasets = dashboards.designer.getDatasets();
                const linkData = this.context.linkData;
                const fromRef = this.isFirstLink
                    ? this.context.datasetRefs[0]
                    : (appn.utils.hasValue(linkData.primaryDatasetIndex) ? this.context.datasetRefs[linkData.primaryDatasetIndex] : undefined);
                const fromRestricted = !!fromRef && dashboards.designer.isRestricted(fromRef.id);
                const toRestricted = dashboards.designer.isRestricted(linkData.linkedDataset.id);
                this.$primaryColumnContainer.toggle(!fromRestricted);
                this.$linkedColumnContainer.toggle(!toRestricted);
                this.$linkedDatasetAlias.val(linkData.linkedDataset.alias || '');
                this.$primaryDataset.empty();
                if (this.isFirstLink) {
                    const primaryRef = this.context.datasetRefs[0];
                    if (primaryRef) {
                        const name = getDatasetRefName(primaryRef);
                        const text = appn.utils.hasValue(primaryRef.alias) && name !== primaryRef.alias
                            ? `${name} (${primaryRef.alias})` : name;
                        const $opt = $('<option>').val(0).text(text);
                        this._styleRestrictedOption($opt, primaryRef.id);
                        this.$primaryDataset.append($opt);
                        this.$primaryDataset.val('0');
                    }
                    this.$primaryDataset.prop('disabled', true);
                }
                else {
                    this.$primaryDataset.append(`<option value="">${T('Choose dataset')}...</option>`);
                    this.context.datasetRefs.forEach((t, index) => {
                        const name = getDatasetRefName(t);
                        const text = appn.utils.hasValue(t.alias) && name !== t.alias ? `${name} (${t.alias})` : name;
                        const $opt = $('<option>').val(index).text(text);
                        this._styleRestrictedOption($opt, t.id);
                        this.$primaryDataset.append($opt);
                    });
                    const primaryIndexValue = appn.utils.hasValue(linkData.primaryDatasetIndex) ? linkData.primaryDatasetIndex.toString() : '';
                    this.$primaryDataset.val(primaryIndexValue);
                    this.$primaryDataset.prop('disabled', false);
                }
                this.$primaryColumn.empty().append(`<option value="">${T('Choose column')}...</option>`);
                if (fromRef) {
                    const fromDataset = datasets.find(t => t.id === fromRef.id);
                    if (fromDataset) {
                        fromDataset.columns.forEach(col => {
                            this.$primaryColumn.append($('<option>')
                                .val(col.id)
                                .text(dashboards.getColumnOptionText(col)));
                        });
                        this.$primaryColumn.val(linkData.primaryColumnId || '');
                    }
                }
                this.$linkedDataset.empty().append(`<option value="">${T('Choose dataset')}...</option>`);
                datasets.forEach(t => {
                    const $opt = $('<option>').val(t.id);
                    dashboards.buildDatasetOption($opt, t);
                    this.$linkedDataset.append($opt);
                });
                const restrictedDatasetIds = this.context.restrictedDatasetIds;
                dashboards.designer.getRestrictedDatasets()
                    .filter(t => t.id === linkData.linkedDataset.id || restrictedDatasetIds.has(t.id))
                    .forEach(t => {
                    const $opt = $('<option>').val(t.id).attr('data-restricted', 'true');
                    dashboards.buildDatasetOption($opt, t, true);
                    this.$linkedDataset.append($opt);
                });
                this.$linkedDataset.val(linkData.linkedDataset.id || '');
                this.$linkedColumn.empty().append(`<option value="">${T('Choose column')}...</option>`);
                const toDataset = datasets.find(t => t.id === linkData.linkedDataset.id);
                if (toDataset) {
                    toDataset.columns.forEach(col => {
                        this.$linkedColumn.append($('<option>')
                            .val(col.id)
                            .text(dashboards.getColumnOptionText(col)));
                    });
                    this.$linkedColumn.val(linkData.linkedColumnId || '');
                }
                const hasFromColumn = !!linkData.primaryColumnId;
                const hasToDataset = !!linkData.linkedDataset.id;
                this.$primaryColumn.prop('disabled', !fromRef);
                this.$linkedDataset.prop('disabled', !toRestricted && !fromRestricted && !hasFromColumn);
                this.$linkedColumn.prop('disabled', !hasToDataset);
                this.$linkedDatasetAlias.prop('disabled', !hasToDataset);
            }
            _styleRestrictedOption($opt, datasetId) {
                const restrictedMeta = dashboards.designer.getRestrictedDatasets().find(d => d.id === datasetId);
                if (!restrictedMeta)
                    return;
                $opt.attr('data-icon-class', 'fa fa-lock');
                $opt.attr('data-container-class', 'restricted-option text-danger');
            }
            bindEvents() {
                this.$datasetLinkRow.on('click', '.removeLink', () => { var _a; return (_a = this.context) === null || _a === void 0 ? void 0 : _a.onDelete(); });
                this.$datasetLinkRow.on('input', '.linkedDatasetAlias', e => {
                    if (this.context) {
                        this.context.linkData.linkedDataset.alias = $(e.target).val();
                        this.context.onInput(this.context.linkData);
                    }
                });
                this.$datasetLinkRow.on('change', '.linkedDatasetAlias', e => {
                    if (this.context) {
                        this.context.linkData.linkedDataset.alias = $(e.target).val();
                        this.context.onChanged(this.context.linkData, false);
                    }
                });
                this.$datasetLinkRow.on('change', '.linkedDatasetSelect', e => {
                    if (!this.context)
                        return;
                    const datasetId = $(e.target).val();
                    const dataset = dashboards.designer.getDatasets().find(t => t.id === datasetId)
                        || dashboards.designer.getRestrictedDatasets().find(t => t.id === datasetId);
                    let newLink = appn.utils.deepClone(this.context.linkData);
                    if (dataset) {
                        newLink.linkedDataset.id = dataset.id;
                        if (dataset.columns.length > 0)
                            newLink.linkedColumnId = dataset.columns[0].id;
                        else if (this.context.linkData.linkedDataset.id !== dataset.id)
                            newLink.linkedColumnId = '';
                    }
                    else {
                        newLink.linkedDataset.id = '';
                        newLink.linkedColumnId = '';
                    }
                    newLink.linkedDataset.alias = '';
                    this.context.onChanged(newLink, false);
                });
                this.$datasetLinkRow.on('change', '.linkedColumnSelect', e => {
                    if (this.context) {
                        this.context.onChanged(Object.assign(Object.assign({}, this.context.linkData), { linkedColumnId: $(e.target).val() }), true);
                    }
                });
                this.$datasetLinkRow.on('change', '.primaryDatasetSelect', e => {
                    if (!this.context || this.isFirstLink)
                        return;
                    const indexStr = $(e.target).val();
                    const index = indexStr ? parseInt(indexStr, 10) : undefined;
                    this.context.onChanged(Object.assign(Object.assign({}, this.context.linkData), { primaryDatasetIndex: index, primaryColumnId: '' }), false);
                });
                this.$datasetLinkRow.on('change', '.primaryColumnSelect', e => {
                    if (this.context)
                        this.context.onChanged(Object.assign(Object.assign({}, this.context.linkData), { primaryColumnId: $(e.target).val() }), false);
                });
            }
            destroy() {
                this.$datasetLinkRow.remove();
            }
        }
        class DatasetSelectorEditor extends DataQueryEditorBase {
            constructor() {
                super(...arguments);
                this.linkEditors = [];
                this.datasets = [];
                this._restrictedDatasets = [];
                this._loadedQueryDatasetIds = new Set();
                this._queryGuard = null;
            }
            init() {
                var _a;
                this.$datasetSelect = this.$editor.find('.primaryDsSelect');
                this.$aliasInput = this.$editor.find('.primaryDsAlias');
                this.$aliasContainer = this.$editor.find('.primaryDsAliasContainer');
                this.$linksList = this.$editor.find('.dataSourceLinksList');
                this.$addLink = this.$editor.find('.addLink');
                this.datasets = dashboards.designer.getDatasets();
                this._restrictedDatasets = dashboards.designer.getRestrictedDatasets();
                const loadedQuery = (_a = dashboards.designer.getRootSnapshot(this.component.id, this.propertyRoot)) === null || _a === void 0 ? void 0 : _a.value;
                if (loadedQuery) {
                    this._loadedQueryDatasetIds = new Set(dashboards.getDatasetRefsInDataQuery(loadedQuery).map(r => r.id));
                    this._syncQueryGuard(loadedQuery);
                }
            }
            _syncQueryGuard(dataQuery) {
                if (this.isDataQueryRestricted(dataQuery)) {
                    if (!this._queryGuard)
                        this._queryGuard = this.guardMyPath();
                }
                else if (this._queryGuard) {
                    this._queryGuard.release();
                    this._queryGuard = null;
                }
            }
            setValue(newValue) {
                super.setValue(newValue);
                this._syncQueryGuard(this.getValue());
            }
            _guardAndRestoreQuery() {
                var _a, _b;
                (_a = this._queryGuard) === null || _a === void 0 ? void 0 : _a.release();
                this._queryGuard = this.guardMyPath();
                (_b = dashboards.designer.getRootSnapshot(this.component.id, this.propertyRoot)) === null || _b === void 0 ? void 0 : _b.restore();
            }
            isDataQueryRestricted(dataQuery) {
                var _a;
                if (!((_a = dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.primaryDataset) === null || _a === void 0 ? void 0 : _a.id))
                    return false;
                if (dashboards.designer.isRestricted(dataQuery.primaryDataset.id))
                    return true;
                return (dataQuery.links || []).some(link => { var _a; return dashboards.designer.isRestricted((_a = link.linkedDataset) === null || _a === void 0 ? void 0 : _a.id); });
            }
            update() {
                var _a, _b, _c, _d, _e, _f, _g;
                const dataQuery = this.getValue();
                const datasets = this.datasets;
                this.$datasetSelect.empty().append('<option value="">Choose dataset...</option>');
                datasets.forEach(t => {
                    const $opt = $('<option>').val(t.id);
                    dashboards.buildDatasetOption($opt, t);
                    this.$datasetSelect.append($opt);
                });
                const boundRestrictedIds = new Set(dashboards.getDatasetRefsInDataQuery(dataQuery).map(r => r.id));
                this._restrictedDatasets.filter(t => this._loadedQueryDatasetIds.has(t.id) || boundRestrictedIds.has(t.id)).forEach(t => {
                    const $opt = $('<option>').val(t.id).attr('data-restricted', 'true');
                    dashboards.buildDatasetOption($opt, t, true);
                    this.$datasetSelect.append($opt);
                });
                this.$datasetSelect.val(((_a = dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.primaryDataset) === null || _a === void 0 ? void 0 : _a.id) || '');
                const isRestricted = this.isDataQueryRestricted(dataQuery);
                this.$aliasContainer.toggle(!!((_b = dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.primaryDataset) === null || _b === void 0 ? void 0 : _b.id) && !isRestricted);
                if ((_c = dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.primaryDataset) === null || _c === void 0 ? void 0 : _c.id) {
                    this.$aliasInput.val(dataQuery.primaryDataset.alias || '').prop('disabled', isRestricted);
                    this.$aliasInput.attr('placeholder', 'Alias (Optional)');
                }
                else {
                    this.$aliasInput.val('').prop('disabled', true);
                    this.$aliasInput.attr('placeholder', 'Alias');
                }
                const links = (dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.links) || [];
                while (this.linkEditors.length > links.length)
                    (_d = this.linkEditors.pop()) === null || _d === void 0 ? void 0 : _d.destroy();
                const datasetRefs = [];
                if ((_e = dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.primaryDataset) === null || _e === void 0 ? void 0 : _e.id)
                    datasetRefs.push(Object.assign({}, dataQuery.primaryDataset));
                const allowedRestrictedIds = new Set([...this._loadedQueryDatasetIds, ...boundRestrictedIds]);
                links.forEach((link, index) => {
                    if (this.linkEditors.length <= index)
                        this.linkEditors.push(new DatasetLinkEditor(this.$linksList));
                    const isFirstLink = index === 0;
                    this.linkEditors[index].update({
                        linkData: link,
                        datasets: datasets,
                        datasetRefs: [...datasetRefs],
                        restrictedDatasetIds: allowedRestrictedIds,
                        onInput: (newLinkData) => {
                            const dataQuery = this.getValueForEdit();
                            const oldAlias = dataQuery.links[index].linkedDataset.alias;
                            dataQuery.links[index] = newLinkData;
                            this.setValue(dataQuery);
                            if (oldAlias !== newLinkData.linkedDataset.alias) {
                                distill.eventBus.publish(dashboards.DASH_EVENTS.ALIAS_CHANGED, {
                                    componentId: this.component.id,
                                    oldAlias: oldAlias,
                                    newAlias: newLinkData.linkedDataset.alias
                                });
                            }
                        },
                        onChanged: (newLinkData, forceAliasCheck = false) => {
                            var _a, _b;
                            const dataQuery = this.getValueForEdit();
                            const oldLinkDatasetId = dataQuery.links[index].linkedDataset.id;
                            const oldAlias = dataQuery.links[index].linkedDataset.alias;
                            dataQuery.links[index] = newLinkData;
                            const loadedQuery = (_a = dashboards.designer.getRootSnapshot(this.component.id, this.propertyRoot)) === null || _a === void 0 ? void 0 : _a.value;
                            if (oldLinkDatasetId !== newLinkData.linkedDataset.id
                                && dashboards.designer.isRestricted(newLinkData.linkedDataset.id)
                                && ((_b = loadedQuery === null || loadedQuery === void 0 ? void 0 : loadedQuery.links) === null || _b === void 0 ? void 0 : _b.some(l => { var _a; return ((_a = l.linkedDataset) === null || _a === void 0 ? void 0 : _a.id) === newLinkData.linkedDataset.id; }))) {
                                this._guardAndRestoreQuery();
                                return;
                            }
                            if (oldLinkDatasetId !== newLinkData.linkedDataset.id) {
                                const thisLinkContextIndex = index + 1;
                                for (let k = index + 1; k < dataQuery.links.length; k++) {
                                    if (dataQuery.links[k].primaryDatasetIndex === thisLinkContextIndex) {
                                        dataQuery.links[k].primaryDatasetIndex = undefined;
                                        dataQuery.links[k].primaryColumnId = '';
                                    }
                                }
                            }
                            this._runAliasDeduplication(dataQuery, newLinkData.linkedDataset, forceAliasCheck);
                            this.setValue(dataQuery);
                            if (oldAlias !== newLinkData.linkedDataset.alias) {
                                distill.eventBus.publish(dashboards.DASH_EVENTS.ALIAS_CHANGED, {
                                    componentId: this.component.id,
                                    oldAlias: oldAlias,
                                    newAlias: newLinkData.linkedDataset.alias
                                });
                            }
                        },
                        onDelete: () => {
                            const dataQuery = this.getValueForEdit();
                            dataQuery.links.splice(index, 1);
                            const deletedLinkContextIndex = index + 1;
                            for (let k = index; k < dataQuery.links.length; k++) {
                                if (dataQuery.links[k].primaryDatasetIndex === deletedLinkContextIndex) {
                                    dataQuery.links[k].primaryDatasetIndex = undefined;
                                    dataQuery.links[k].primaryColumnId = '';
                                }
                                if (appn.utils.hasValue(dataQuery.links[k].primaryDatasetIndex) && dataQuery.links[k].primaryDatasetIndex > deletedLinkContextIndex)
                                    dataQuery.links[k].primaryDatasetIndex--;
                            }
                            this.setValue(dataQuery);
                        }
                    }, isFirstLink);
                    if (link.linkedDataset.id) {
                        datasetRefs.push({
                            id: link.linkedDataset.id,
                            alias: link.linkedDataset.alias
                        });
                    }
                });
                const isLinkWellDefined = (link, linkIndex) => {
                    const hasToDataset = !!link.linkedDataset.id;
                    const hasToColumn = !!link.linkedColumnId;
                    const hasFromColumn = !!link.primaryColumnId;
                    const hasFromDataset = linkIndex === 0 || appn.utils.hasValue(link.primaryDatasetIndex);
                    return hasToDataset && hasToColumn && hasFromDataset && hasFromColumn;
                };
                const allLinksWellDefined = ((dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.links) || []).every((link, idx) => isLinkWellDefined(link, idx));
                const isDatasetSelected = !!((_f = dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.primaryDataset) === null || _f === void 0 ? void 0 : _f.id);
                const primaryRestricted = dashboards.designer.isRestricted((_g = dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.primaryDataset) === null || _g === void 0 ? void 0 : _g.id);
                this.$addLink.toggle(!primaryRestricted && isDatasetSelected && allLinksWellDefined);
                appn.select.initForDesign({
                    elements: this.$editor.find('.primaryDsSelect, .primaryDatasetSelect, .linkedDatasetSelect'),
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH,
                    isIconTextSelect: true,
                    isHierarchical: true
                });
                appn.select.initForDesign({
                    elements: this.$editor.find('select').not('.primaryDsSelect, .linkedDatasetSelect'),
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
            }
            bindEvents() {
                this.$editor.on('change', '.primaryDsSelect', e => {
                    var _a, _b;
                    const datasetId = $(e.target).val();
                    const dataset = this.datasets.find(t => t.id === datasetId) || this._restrictedDatasets.find(t => t.id === datasetId);
                    if (!dataset) {
                        this.setValue(null);
                        return;
                    }
                    const loadedQuery = (_a = dashboards.designer.getRootSnapshot(this.component.id, this.propertyRoot)) === null || _a === void 0 ? void 0 : _a.value;
                    if (dashboards.designer.isRestricted(dataset.id) && ((_b = loadedQuery === null || loadedQuery === void 0 ? void 0 : loadedQuery.primaryDataset) === null || _b === void 0 ? void 0 : _b.id) === dataset.id) {
                        this._guardAndRestoreQuery();
                        return;
                    }
                    const dataQuery = this.getValueForEdit() || {
                        name: 'default',
                        primaryDataset: { id: '', alias: '' },
                        links: [],
                        filter: null,
                        aggregation: null,
                        aggregationFilter: null,
                        projection: null,
                        sortOrders: [],
                        limit: null,
                        offset: null
                    };
                    if (!dataQuery.primaryDataset)
                        dataQuery.primaryDataset = { id: '', alias: '' };
                    const oldDatasetId = dataQuery.primaryDataset.id;
                    dataQuery.primaryDataset.id = dataset.id;
                    if (oldDatasetId !== dataset.id) {
                        dataQuery.primaryDataset.alias = '';
                        if (dataQuery.links) {
                            dataQuery.links.forEach(link => {
                                if (link.primaryDatasetIndex === 0) {
                                    link.primaryDatasetIndex = undefined;
                                    link.primaryColumnId = '';
                                }
                            });
                        }
                    }
                    this.setValue(dataQuery);
                });
                this.$editor.on('input', '.primaryDsAlias', e => {
                    const dataQuery = this.getValueForEdit();
                    if (dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.primaryDataset) {
                        const oldAlias = dataQuery.primaryDataset.alias;
                        const newAlias = $(e.target).val();
                        dataQuery.primaryDataset.alias = newAlias;
                        this.setValue(dataQuery);
                        if (oldAlias !== newAlias) {
                            distill.eventBus.publish(dashboards.DASH_EVENTS.ALIAS_CHANGED, {
                                componentId: this.component.id,
                                oldAlias: oldAlias,
                                newAlias: newAlias
                            });
                        }
                    }
                });
                this.$editor.on('change', '.primaryDsAlias', e => {
                    const dataQuery = this.getValueForEdit();
                    if (dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.primaryDataset) {
                        dataQuery.primaryDataset.alias = $(e.target).val();
                        this._runAliasDeduplication(dataQuery, dataQuery.primaryDataset, false);
                        this.setValue(dataQuery);
                    }
                });
                this.$editor.on('click', '.addLink', () => {
                    const dataQuery = this.getValueForEdit();
                    if (!dataQuery.links)
                        dataQuery.links = [];
                    const isFirstLink = dataQuery.links.length === 0;
                    const primaryDatasetIndex = isFirstLink ? 0 : undefined;
                    dataQuery.links.push({
                        linkedDataset: { id: '', alias: '' },
                        linkedColumnId: '',
                        primaryDatasetIndex: primaryDatasetIndex,
                        primaryColumnId: ''
                    });
                    this.setValue(dataQuery);
                });
            }
            _runAliasDeduplication(dataQuery, changedDatasetRef, forceCheckBlankAlias = false) {
                var _a;
                const datasetRefs = [dataQuery.primaryDataset, ...(_a = dataQuery.links) === null || _a === void 0 ? void 0 : _a.map(l => l.linkedDataset)];
                const allOtherDatasets = datasetRefs.filter(t => t !== changedDatasetRef);
                const allOtherAliases = new Set(allOtherDatasets.map(t => t.alias).filter(a => a));
                const allOtherNames = new Set(allOtherDatasets.map(t => getDatasetRefName(t)).filter(n => n));
                let currentAlias = changedDatasetRef.alias;
                if (currentAlias) {
                    let finalAlias = currentAlias;
                    let counter = 1;
                    while (allOtherAliases.has(finalAlias) || allOtherNames.has(finalAlias)) {
                        finalAlias = `${currentAlias}_${counter++}`;
                    }
                    changedDatasetRef.alias = finalAlias;
                }
                else if (forceCheckBlankAlias) {
                    const changedDatasetName = getDatasetRefName(changedDatasetRef);
                    const conflictsWithAlias = allOtherAliases.has(changedDatasetName);
                    const conflictsWithName = allOtherNames.has(changedDatasetName);
                    if (conflictsWithAlias || conflictsWithName) {
                        let baseAlias = changedDatasetName;
                        let finalAlias = baseAlias;
                        let counter = 1;
                        while (allOtherAliases.has(finalAlias) || allOtherNames.has(finalAlias))
                            finalAlias = `${baseAlias}_${counter++}`;
                        changedDatasetRef.alias = finalAlias;
                    }
                }
            }
            destroy() {
                var _a;
                (_a = this._queryGuard) === null || _a === void 0 ? void 0 : _a.release();
                this._queryGuard = null;
                this.linkEditors.forEach(editor => editor.destroy());
                this.linkEditors = [];
                super.destroy();
            }
        }
        const GLOBAL_FILTER_TYPES_BY_OPERATOR = {
            'Equals': [dashboards.DashboardGlobalFilterType.Text], 'NotEquals': [dashboards.DashboardGlobalFilterType.Text],
            'Contains': [dashboards.DashboardGlobalFilterType.Text], 'NotContains': [dashboards.DashboardGlobalFilterType.Text],
            'StartsWith': [dashboards.DashboardGlobalFilterType.Text], 'NotStartsWith': [dashboards.DashboardGlobalFilterType.Text],
            'EndsWith': [dashboards.DashboardGlobalFilterType.Text], 'NotEndsWith': [dashboards.DashboardGlobalFilterType.Text],
            'In': [dashboards.DashboardGlobalFilterType.Dropdown], 'NotIn': [dashboards.DashboardGlobalFilterType.Dropdown],
            'Between': [dashboards.DashboardGlobalFilterType.DateRange, dashboards.DashboardGlobalFilterType.NumberRange],
            'NotBetween': [dashboards.DashboardGlobalFilterType.DateRange, dashboards.DashboardGlobalFilterType.NumberRange],
            'GreaterThan': [dashboards.DashboardGlobalFilterType.DateRange, dashboards.DashboardGlobalFilterType.NumberRange],
            'GreaterThanOrEqual': [dashboards.DashboardGlobalFilterType.DateRange, dashboards.DashboardGlobalFilterType.NumberRange],
            'LessThan': [dashboards.DashboardGlobalFilterType.DateRange, dashboards.DashboardGlobalFilterType.NumberRange],
            'LessThanOrEqual': [dashboards.DashboardGlobalFilterType.DateRange, dashboards.DashboardGlobalFilterType.NumberRange]
        };
        function getGlobalFiltersForValueType(operator, numericTarget) {
            var _a;
            const allowedTypes = numericTarget
                ? [dashboards.DashboardGlobalFilterType.NumberRange]
                : (operator ? GLOBAL_FILTER_TYPES_BY_OPERATOR[operator] : undefined) || [];
            return (((_a = dashboards.designer._design) === null || _a === void 0 ? void 0 : _a.globalFilters) || [])
                .filter(f => allowedTypes.includes(f.type));
        }
        class FilterCriterionValueEditor {
            constructor(container, onValueChanged) {
                this.valueType = 'static';
                this.hasLoadedValueType = false;
                this.$root = appn.utils.cloneTemplate('editor-filterCriterionValue');
                container.append(this.$root);
                this.onValueChanged = onValueChanged;
                this.context = {
                    currentColumnType: null,
                    datasetRefs: [],
                    compatibleTypes: [],
                    value: undefined,
                    dynamicValue: undefined,
                    datasetIndex: undefined,
                    columnId: undefined,
                    operator: undefined,
                    globalFilterId: undefined
                };
                this.$staticGroup = this.$root.find('.value-static-group');
                this.$dynamicGroup = this.$root.find('.value-dynamic-group');
                this.$columnGroup = this.$root.find('.value-column-group');
                this.$globalFilterGroup = this.$root.find('.value-globalfilter-group');
                this.$valueText = this.$root.find('.filterValueText');
                this.$valueNumeric = this.$root.find('.filterValueNumeric');
                this.$valueDate = this.$root.find('.filterValueDate');
                this.$dynamicInput = this.$root.find('.filterDynamicValue');
                this.$columnSelect = this.$root.find('.filterValueColumnSelect');
                this.$globalFilterSelect = this.$root.find('.filterGlobalFilterSelect');
                this.initValueTypeSelects();
                this.initDatePicker();
                this.bindEvents();
            }
            get datePicker() {
                return this.$valueDate.data('DateTimePicker') || null;
            }
            initDatePicker() {
                appn.ui.dateTimePicker(this.$valueDate, () => this.onDatePickerChanged());
                const picker = this.datePicker;
                if (picker)
                    picker.useCurrent('day');
            }
            onDatePickerChanged() {
                var _a;
                const selectedMoment = (_a = this.datePicker) === null || _a === void 0 ? void 0 : _a.date();
                let finalValue;
                if (selectedMoment && (typeof selectedMoment.isValid === 'function' ? selectedMoment.isValid() : selectedMoment))
                    finalValue = selectedMoment.format('YYYY-MM-DDTHH:mm:ss') + 'Z';
                this.context.value = finalValue;
                this.onValueChanged({ value: finalValue });
            }
            setDatePickerValue(value) {
                var _a;
                const picker = this.datePicker;
                if (!picker) {
                    this.$valueDate.val((_a = value === null || value === void 0 ? void 0 : value.trim()) !== null && _a !== void 0 ? _a : '');
                    return;
                }
                const dateVal = value === null || value === void 0 ? void 0 : value.trim();
                if (!dateVal) {
                    picker.clear();
                    return;
                }
                const parsed = window.moment.utc(dateVal);
                if (parsed.isValid())
                    picker.date(parsed);
                else
                    picker.clear();
            }
            update(context) {
                this.context = context;
                if (!this.hasLoadedValueType) {
                    if (this.context.globalFilterId)
                        this.valueType = 'globalFilter';
                    else if (this.context.datasetIndex != null && this.context.columnId)
                        this.valueType = 'column';
                    else if (this.context.dynamicValue)
                        this.valueType = 'dynamic';
                    else
                        this.valueType = 'static';
                    this.hasLoadedValueType = true;
                }
                this.renderUI();
            }
            show() {
                this.$root.show();
            }
            hide() {
                this.$root.hide();
            }
            renderUI() {
                this.$root.find('.valueTypeSelect')
                    .val(this.valueType)
                    .trigger('change.select2');
                this.$staticGroup.toggle(this.valueType === 'static');
                this.$dynamicGroup.toggle(this.valueType === 'dynamic');
                this.$columnGroup.toggle(this.valueType === 'column');
                this.$globalFilterGroup.toggle(this.valueType === 'globalFilter');
                this.$valueText.hide();
                this.$valueNumeric.hide();
                this.$valueDate.hide();
                if (this.valueType === 'globalFilter')
                    this.populateGlobalFilterSelect();
                else if (this.valueType === 'static') {
                    const columnType = this.context.currentColumnType;
                    let $input;
                    if (columnType === 'Number')
                        $input = this.$valueNumeric;
                    else if (columnType === 'Date')
                        $input = this.$valueDate;
                    else
                        $input = this.$valueText;
                    $input.show();
                    const value = this.context.value;
                    if (columnType === 'Date')
                        this.setDatePickerValue(value || '');
                    else
                        $input.val(value || '');
                }
                else if (this.valueType === 'dynamic')
                    this.$dynamicInput.val(this.context.dynamicValue || '');
                else if (this.valueType === 'column') {
                    const currentValue = this.context.datasetIndex != null && this.context.columnId
                        ? `${this.context.datasetIndex}|${this.context.columnId}` : '';
                    const typeFilter = this.context.compatibleTypes.length > 0
                        ? this.context.compatibleTypes
                        : null;
                    dashboards.populatePrefixedColumnSelect(this.$columnSelect, this.context.datasetRefs, typeFilter, currentValue);
                }
            }
            initValueTypeSelects() {
                appn.select.initForDesign({
                    elements: this.$root.find('.valueTypeSelect'),
                    isIconButtonSelect: true,
                    omitWidth: true
                });
                this.$root.find('.valueTypeSelect').on('select2:select', (e) => {
                    const newType = e.params.data.id;
                    if (newType !== this.valueType) {
                        this.valueType = newType;
                        this.renderUI();
                    }
                });
            }
            openFormulaBuilder() {
                var _a, _b;
                const currentValue = this.context.dynamicValue;
                appn.ui.formulabuilder.controlName = 'FilterValue';
                appn.ui.formulabuilder.$input = this.$dynamicInput;
                appn.ui.formulabuilder.currentFormula = currentValue || '';
                appn.ui.formulabuilder.currentMode = (_b = (_a = appn.designerv2) === null || _a === void 0 ? void 0 : _a.FormulaType) === null || _b === void 0 ? void 0 : _b.normal;
                appn.ui.formulabuilder.isFormula = true;
                appn.ui.formulabuilder.formulaUpdated = (formula) => {
                    this.$dynamicInput.val(formula).trigger('input');
                };
                appn.ui.formulabuilder.showDialog();
            }
            bindEvents() {
                this.$root.on('input change', '.filterValueText, .filterValueNumeric', (e) => {
                    const target = $(e.currentTarget);
                    let rawValue = target.val();
                    let finalValue;
                    if (!rawValue || rawValue === '')
                        finalValue = undefined;
                    else
                        finalValue = rawValue;
                    this.context.value = finalValue;
                    this.onValueChanged({ value: finalValue });
                });
                this.$root.on('change', '.filterDynamicValue', (e) => {
                    const val = $(e.target).val();
                    this.context.dynamicValue = val || undefined;
                    this.onValueChanged({ dynamicValue: val || undefined });
                });
                this.$root.on('click', '.buildDynamicIcon', (e) => {
                    e.preventDefault();
                    this.openFormulaBuilder();
                });
                this.$root.on('change', '.filterValueColumnSelect', (e) => {
                    const val = $(e.target).val();
                    if (val) {
                        const [datasetIndex, columnId] = val.split('|');
                        this.context.datasetIndex = parseInt(datasetIndex, 10);
                        this.context.columnId = columnId;
                        this.onValueChanged({ datasetIndex: parseInt(datasetIndex, 10), columnId: columnId });
                    }
                    else {
                        this.context.datasetIndex = undefined;
                        this.context.columnId = undefined;
                        this.onValueChanged({ datasetIndex: undefined, columnId: undefined });
                    }
                });
                this.$root.on('change', '.filterGlobalFilterSelect', (e) => {
                    const val = $(e.target).val();
                    this.context.globalFilterId = val || undefined;
                    this.onValueChanged({ globalFilterId: val || undefined });
                });
            }
            populateGlobalFilterSelect() {
                const compatible = getGlobalFiltersForValueType(this.context.operator, false);
                const current = this.context.globalFilterId || '';
                this.$globalFilterSelect.empty().append(`<option value="">${T('Choose global filter')}...</option>`);
                compatible.forEach(f => this.$globalFilterSelect.append($('<option>').val(f.id).text(f.label || f.id)));
                appn.select.initForDesign({
                    elements: this.$globalFilterSelect.not('.select2-hidden-accessible'),
                    omitWidth: true,
                    minimumResultsForSearch: '10'
                });
                this.$globalFilterSelect.val(compatible.some(f => f.id === current) ? current : '')
                    .trigger('change.select2');
            }
            destroy() {
                this.$root.remove();
            }
        }
        class FilterCriterionEditor {
            static cleanFilterCriterion(criterion, columnType) {
                var _a;
                const cleaned = Object.assign({}, criterion);
                if (cleaned.globalFilterId) {
                    cleaned.value = undefined;
                    cleaned.dynamicValue = undefined;
                    cleaned.valueDatasetIndex = undefined;
                    cleaned.valueColumnId = undefined;
                    cleaned.value2 = undefined;
                    cleaned.dynamicValue2 = undefined;
                    cleaned.value2DatasetIndex = undefined;
                    cleaned.value2ColumnId = undefined;
                    return cleaned;
                }
                const operator = cleaned.operator || 'Equals';
                const req = FilterCriterionEditor.operatorRequirements[operator];
                const valuesNeeded = req ? req.values : 0;
                const normaliseValueSlot = (valueSlot) => {
                    const { value, dynamicValue, datasetIndex, columnId } = valueSlot;
                    if (datasetIndex != null && columnId)
                        return { datasetIndex, columnId };
                    if (dynamicValue)
                        return { dynamicValue };
                    return { value };
                };
                if (valuesNeeded >= 1) {
                    const valueSlot = normaliseValueSlot({
                        value: cleaned.value,
                        dynamicValue: cleaned.dynamicValue,
                        datasetIndex: cleaned.valueDatasetIndex,
                        columnId: cleaned.valueColumnId
                    });
                    cleaned.value = valueSlot.value;
                    cleaned.dynamicValue = valueSlot.dynamicValue;
                    cleaned.valueDatasetIndex = valueSlot.datasetIndex;
                    cleaned.valueColumnId = valueSlot.columnId;
                }
                else {
                    cleaned.value = undefined;
                    cleaned.dynamicValue = undefined;
                    cleaned.valueDatasetIndex = undefined;
                    cleaned.valueColumnId = undefined;
                }
                if (valuesNeeded >= 2) {
                    const value2Slot = normaliseValueSlot({
                        value: cleaned.value2,
                        dynamicValue: cleaned.dynamicValue2,
                        datasetIndex: cleaned.value2DatasetIndex,
                        columnId: cleaned.value2ColumnId
                    });
                    cleaned.value2 = value2Slot.value;
                    cleaned.dynamicValue2 = value2Slot.dynamicValue;
                    cleaned.value2DatasetIndex = value2Slot.datasetIndex;
                    cleaned.value2ColumnId = value2Slot.columnId;
                }
                else {
                    cleaned.value2 = undefined;
                    cleaned.dynamicValue2 = undefined;
                    cleaned.value2DatasetIndex = undefined;
                    cleaned.value2ColumnId = undefined;
                }
                if (columnType && req && !req.types.includes(columnType)) {
                    const defaultOp = FilterCriterionEditor.defaultOperatorMap[columnType];
                    if (defaultOp && ((_a = FilterCriterionEditor.operatorRequirements[defaultOp]) === null || _a === void 0 ? void 0 : _a.types.includes(columnType)))
                        cleaned.operator = defaultOp;
                    else {
                        for (const opKey in FilterCriterionEditor.operatorRequirements) {
                            const opReq = FilterCriterionEditor.operatorRequirements[opKey];
                            if (opReq && opReq.types.includes(columnType)) {
                                cleaned.operator = opKey;
                                break;
                            }
                        }
                    }
                }
                return cleaned;
            }
            constructor(container, criterion, datasetRefs, onChanged, onDelete) {
                this.valueEditor1 = null;
                this.valueEditor2 = null;
                this.availableColumns = [];
                this.currentColumnType = null;
                this.$filterCriterionRow = appn.utils.cloneTemplate('editor-filterCriterionRow');
                container.append(this.$filterCriterionRow);
                this.criterion = criterion;
                this.datasetRefs = datasetRefs;
                this.onChanged = onChanged;
                this.onDelete = onDelete;
                this.$column = this.$filterCriterionRow.find('.filterColumnSelect');
                this.$operator = this.$filterCriterionRow.find('.filterOperatorSelect');
                this.$removeCriterion = this.$filterCriterionRow.find('.removeBtn');
                this.$allOperatorOptions = this.$operator.find('option').clone();
                this.$valueArea = this.$filterCriterionRow.find('.value-input-area');
                this.$valuePlaceholder = this.$valueArea.find('.filterValuePlaceholder');
                this.$value1Container = this.$valueArea.find('.value1-input-container');
                this.$value2Row = this.$filterCriterionRow.find('.value2-row');
                this.$valueSeparator = this.$value2Row.find('.value-separator');
                this.$value2Container = this.$value2Row.find('.value2-input-container');
                this.update(criterion, datasetRefs);
                this.bindEvents();
            }
            update(criterion, datasetRefs, onChanged) {
                if (onChanged)
                    this.onChanged = onChanged;
                this.criterion = criterion;
                this.datasetRefs = datasetRefs;
                const selectedValue = appn.utils.hasValue(this.criterion.datasetIndex) && this.criterion.columnId ? `${this.criterion.datasetIndex}|${this.criterion.columnId}` : '';
                this.populateColumns();
                this.$column.val(selectedValue);
                this.updateCurrentColumnType(selectedValue);
                this.populateOperators();
                this.$operator.val(this.criterion.operator || 'Equals');
                this.updateValueInputsVisibilityAndValues();
                this.$filterCriterionRow.toggleClass('filter-criterion-global', !!this.criterion.globalFilterId);
            }
            showDeleteButton(visible) {
                this.$removeCriterion.toggle(visible);
            }
            populateColumns() {
                const selectedValue = appn.utils.hasValue(this.criterion.datasetIndex) && this.criterion.columnId ? `${this.criterion.datasetIndex}|${this.criterion.columnId}` : '';
                const populatedCols = dashboards.populatePrefixedColumnSelect(this.$column, this.datasetRefs, null, selectedValue);
                this.availableColumns = populatedCols.map(c => ({ id: c.id, name: c.displayName, type: c.type }));
            }
            updateCurrentColumnType(selectedValue) {
                var _a;
                if (!selectedValue) {
                    this.currentColumnType = null;
                    return;
                }
                const [, columnId] = selectedValue.split('|');
                const columnMeta = this.availableColumns.find(c => c.id === columnId);
                this.currentColumnType = (_a = columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.type) !== null && _a !== void 0 ? _a : null;
            }
            populateOperators() {
                const currentOperator = this.$operator.val();
                this.$operator.empty();
                const operators = this.$allOperatorOptions.clone();
                operators.each((_, opt) => {
                    const $opt = $(opt);
                    $opt.text($opt.text().toLowerCase());
                    const opValue = $opt.val();
                    const req = FilterCriterionEditor.operatorRequirements[opValue];
                    if (this.currentColumnType && req && req.types.includes(this.currentColumnType))
                        this.$operator.append($opt);
                    else if (!this.currentColumnType)
                        this.$operator.append($opt);
                });
                if (this.$operator.find(`option[value="${currentOperator}"]`).length > 0)
                    this.$operator.val(currentOperator);
                else
                    this.$operator.val('Equals');
            }
            getCompatibleColumnTypes() {
                const operator = this.$operator.val();
                const req = FilterCriterionEditor.operatorRequirements[operator];
                if (!req || !this.currentColumnType)
                    return [];
                if (['Equals', 'NotEquals', 'IsBlank', 'NotIsBlank'].includes(operator))
                    return [this.currentColumnType];
                if (['Contains', 'NotContains', 'StartsWith', 'NotStartsWith', 'EndsWith', 'NotEndsWith'].includes(operator))
                    return ['Text', 'LongText'];
                return req.types;
            }
            updateValueInputsVisibilityAndValues() {
                const operator = this.$operator.val();
                const req = FilterCriterionEditor.operatorRequirements[operator];
                const valuesNeeded = this.criterion.globalFilterId ? 1 : (req ? req.values : 0);
                this.$valuePlaceholder.hide();
                this.$value2Row.hide();
                this.$valueSeparator.hide();
                const createContextForValue1 = () => ({
                    currentColumnType: this.currentColumnType,
                    datasetRefs: this.datasetRefs,
                    compatibleTypes: this.getCompatibleColumnTypes(),
                    value: this.criterion.value,
                    dynamicValue: this.criterion.dynamicValue,
                    datasetIndex: this.criterion.valueDatasetIndex,
                    columnId: this.criterion.valueColumnId,
                    operator: this.criterion.operator,
                    globalFilterId: this.criterion.globalFilterId
                });
                const createContextForValue2 = () => ({
                    currentColumnType: this.currentColumnType,
                    datasetRefs: this.datasetRefs,
                    compatibleTypes: this.getCompatibleColumnTypes(),
                    value: this.criterion.value2,
                    dynamicValue: this.criterion.dynamicValue2,
                    datasetIndex: this.criterion.value2DatasetIndex,
                    columnId: this.criterion.value2ColumnId,
                    operator: this.criterion.operator,
                    globalFilterId: this.criterion.globalFilterId
                });
                if (valuesNeeded === 0) {
                    this.$valuePlaceholder.show();
                    if (this.valueEditor1)
                        this.valueEditor1.hide();
                    if (this.valueEditor2)
                        this.valueEditor2.hide();
                }
                else if (valuesNeeded >= 1) {
                    if (!this.valueEditor1) {
                        this.valueEditor1 = new FilterCriterionValueEditor(this.$value1Container, (updates) => {
                            this.criterion = Object.assign(Object.assign({}, this.criterion), { value: updates.value, dynamicValue: updates.dynamicValue, valueDatasetIndex: updates.datasetIndex, valueColumnId: updates.columnId, globalFilterId: updates.globalFilterId });
                            this.criterion = FilterCriterionEditor.cleanFilterCriterion(this.criterion, this.currentColumnType);
                            this.onChanged(this.criterion);
                        });
                    }
                    this.valueEditor1.update(createContextForValue1());
                    this.valueEditor1.show();
                }
                if (valuesNeeded === 2) {
                    this.$value2Row.show();
                    this.$valueSeparator.show();
                    if (!this.valueEditor2) {
                        this.valueEditor2 = new FilterCriterionValueEditor(this.$value2Container, (updates) => {
                            this.criterion = Object.assign(Object.assign({}, this.criterion), { value2: updates.value, dynamicValue2: updates.dynamicValue, value2DatasetIndex: updates.datasetIndex, value2ColumnId: updates.columnId });
                            this.criterion = FilterCriterionEditor.cleanFilterCriterion(this.criterion, this.currentColumnType);
                            this.onChanged(this.criterion);
                        });
                    }
                    this.valueEditor2.update(createContextForValue2());
                    this.valueEditor2.show();
                }
            }
            bindEvents() {
                this.$filterCriterionRow.on('click', '.removeBtn', () => this.onDelete());
                this.$filterCriterionRow.on('change', '.filterColumnSelect', e => {
                    const val = $(e.target).val();
                    this.criterion = Object.assign(Object.assign({}, this.criterion), { datasetIndex: undefined, columnId: undefined });
                    if (val) {
                        const parts = val.split('|');
                        this.criterion.datasetIndex = parseInt(parts[0], 10);
                        this.criterion.columnId = parts[1];
                    }
                    this.updateCurrentColumnType(val);
                    this.populateOperators();
                    this.criterion.operator = this.$operator.val();
                    this.criterion = FilterCriterionEditor.cleanFilterCriterion(this.criterion, this.currentColumnType);
                    this.onChanged(this.criterion);
                });
                this.$filterCriterionRow.on('change', '.filterOperatorSelect', e => {
                    var _a;
                    const newOperator = $(e.target).val();
                    if (this.criterion.globalFilterId) {
                        const allowedTypes = GLOBAL_FILTER_TYPES_BY_OPERATOR[newOperator] || [];
                        const referenced = (((_a = dashboards.designer._design) === null || _a === void 0 ? void 0 : _a.globalFilters) || [])
                            .find(f => f.id === this.criterion.globalFilterId);
                        if (!referenced || !allowedTypes.includes(referenced.type))
                            this.criterion = Object.assign(Object.assign({}, this.criterion), { globalFilterId: undefined });
                    }
                    this.criterion = Object.assign(Object.assign({}, this.criterion), { operator: newOperator });
                    this.criterion = FilterCriterionEditor.cleanFilterCriterion(this.criterion, this.currentColumnType);
                    this.onChanged(this.criterion);
                });
            }
            destroy() {
                var _a, _b;
                (_a = this.valueEditor1) === null || _a === void 0 ? void 0 : _a.destroy();
                (_b = this.valueEditor2) === null || _b === void 0 ? void 0 : _b.destroy();
                this.$filterCriterionRow.remove();
            }
        }
        FilterCriterionEditor.defaultOperatorMap = {
            'Number': 'Equals',
            'Date': 'GreaterThan',
            'Text': 'Equals',
            'LongText': 'Equals',
            'Boolean': 'Equals',
            'UniqueIdentifier': 'Equals'
        };
        FilterCriterionEditor.operatorRequirements = {
            'Equals': { values: 1, types: ['Text', 'LongText', 'Number', 'Boolean', 'UniqueIdentifier'] },
            'NotEquals': { values: 1, types: ['Text', 'LongText', 'Number', 'Boolean', 'UniqueIdentifier'] },
            'GreaterThan': { values: 1, types: ['Number', 'Date'] },
            'GreaterThanOrEqual': { values: 1, types: ['Number', 'Date'] },
            'LessThan': { values: 1, types: ['Number', 'Date'] },
            'LessThanOrEqual': { values: 1, types: ['Number', 'Date'] },
            'Between': { values: 2, types: ['Number', 'Date'] },
            'NotBetween': { values: 2, types: ['Number', 'Date'] },
            'Contains': { values: 1, types: ['Text', 'LongText'] },
            'NotContains': { values: 1, types: ['Text', 'LongText'] },
            'StartsWith': { values: 1, types: ['Text', 'LongText'] },
            'NotStartsWith': { values: 1, types: ['Text', 'LongText'] },
            'EndsWith': { values: 1, types: ['Text', 'LongText'] },
            'NotEndsWith': { values: 1, types: ['Text', 'LongText'] },
            'IsBlank': { values: 0, types: ['Text', 'LongText', 'Number', 'Date', 'Boolean', 'UniqueIdentifier'] },
            'NotIsBlank': { values: 0, types: ['Text', 'LongText', 'Number', 'Date', 'Boolean', 'UniqueIdentifier'] },
            'In': { values: 1, types: ['Text', 'LongText', 'Number', 'UniqueIdentifier'] },
            'NotIn': { values: 1, types: ['Text', 'LongText', 'Number', 'UniqueIdentifier'] }
        };
        class FilterGroupEditor {
            constructor(container, filterGroup, aliasedDatasets, onChanged, onDelete, isRoot = false) {
                this.childEditors = [];
                this.$filterGroup = isRoot ? container : appn.utils.cloneTemplate('editor-filterGroup');
                if (!isRoot)
                    container.append(this.$filterGroup);
                this.isRoot = isRoot;
                this.filterGroup = filterGroup;
                this.aliasedDatasets = aliasedDatasets;
                this.onChanged = onChanged;
                this.onDelete = onDelete;
                this.operationSelector = isRoot ? '.filterLogicalOperator' : '.groupLogicalOperator';
                this.$operation = this.$filterGroup.find(this.operationSelector);
                this.$conditions = this.$filterGroup.find('.filterConditionsList');
                this.$removeGroup = this.$filterGroup.find('.removeGroupBtn');
                this.update(filterGroup, aliasedDatasets);
                this.bindEvents();
            }
            update(filterGroup, aliasedDatasets, onChanged, onDelete) {
                var _a;
                if (onChanged)
                    this.onChanged = onChanged;
                if (onDelete)
                    this.onDelete = onDelete;
                this.filterGroup = filterGroup;
                this.aliasedDatasets = aliasedDatasets;
                this.$operation.val(this.filterGroup.groupOperator || 'AND');
                const newConditions = this.filterGroup.groupConditions || [];
                while (this.childEditors.length > newConditions.length)
                    (_a = this.childEditors.pop()) === null || _a === void 0 ? void 0 : _a.destroy();
                const canDeleteChildren = this.isRoot || newConditions.length > 2;
                newConditions.forEach((condition, index) => {
                    const onChildChanged = (newChildData) => {
                        this.filterGroup = appn.utils.deepClone(this.filterGroup);
                        this.filterGroup.groupConditions[index] = newChildData;
                        this.onChanged(this.filterGroup);
                    };
                    const onChildDeleted = () => {
                        this.filterGroup = appn.utils.deepClone(this.filterGroup);
                        this.filterGroup.groupConditions.splice(index, 1);
                        if (this.isRoot && this.filterGroup.groupConditions.length === 0)
                            this.onDelete();
                        else
                            this.onChanged(this.filterGroup);
                    };
                    const existingEditor = this.childEditors[index];
                    const isGroup = !!condition.groupConditions;
                    const typeMatches = existingEditor
                        && ((isGroup && existingEditor instanceof FilterGroupEditor)
                            || (!isGroup && existingEditor instanceof FilterCriterionEditor));
                    if (typeMatches)
                        existingEditor.update(condition, this.aliasedDatasets, onChildChanged, onChildDeleted);
                    else {
                        if (existingEditor)
                            existingEditor.destroy();
                        const $listItem = $('<li></li>');
                        this.$conditions.append($listItem);
                        if (isGroup) {
                            $listItem.addClass('mt-1');
                            this.childEditors[index] = new FilterGroupEditor($listItem, condition, this.aliasedDatasets, onChildChanged, onChildDeleted);
                        }
                        else
                            this.childEditors[index] = new FilterCriterionEditor($listItem, condition, this.aliasedDatasets, onChildChanged, onChildDeleted);
                    }
                    const editor = this.childEditors[index];
                    if (editor)
                        editor.showDeleteButton(canDeleteChildren);
                });
            }
            showDeleteButton(visible) {
                this.$removeGroup.toggle(visible);
            }
            bindEvents() {
                const $removeEle = this.$filterGroup.parent().is('li') ? this.$filterGroup.parent() : this.$filterGroup;
                $removeEle.on('click', '.removeGroupBtn', (e) => {
                    e.stopPropagation();
                    this.onDelete();
                });
                this.$filterGroup.on('change', this.operationSelector, e => {
                    this.filterGroup = Object.assign(Object.assign({}, this.filterGroup), { groupOperator: $(e.target).val() });
                    this.onChanged(this.filterGroup);
                });
                this.$filterGroup.on('click', '.addCriterionToGroupBtn, .addFilterCriterion', (e) => {
                    e.stopPropagation();
                    this.addCondition(false);
                });
                this.$filterGroup.on('click', '.addGroupToGroupBtn, .addFilterGroup', (e) => {
                    e.stopPropagation();
                    this.addCondition(true);
                });
            }
            addCondition(isGroup) {
                this.filterGroup = appn.utils.deepClone(this.filterGroup);
                if (!this.filterGroup.groupConditions)
                    this.filterGroup.groupConditions = [];
                if (isGroup) {
                    this.filterGroup.groupConditions.push({
                        groupOperator: 'OR',
                        groupConditions: [
                            { datasetIndex: 0, columnId: '', operator: 'Equals', value: '' },
                            { datasetIndex: 0, columnId: '', operator: 'Equals', value: '' }
                        ]
                    });
                }
                else
                    this.filterGroup.groupConditions.push({ datasetIndex: 0, columnId: '', operator: 'Equals', value: '' });
                this.onChanged(this.filterGroup);
            }
            destroy() {
                this.childEditors.forEach(c => c.destroy());
                this.childEditors = [];
                if (!this.$filterGroup.parent().is('li'))
                    this.$filterGroup.remove();
                else
                    this.$filterGroup.parent().remove();
            }
        }
        class FiltersEditor extends DataQueryEditorBase {
            constructor() {
                super(...arguments);
                this.rootGroupEditor = null;
            }
            init() {
                this.$multiCriteriaHint = this.$editor.find('.filterMultiCriteriaHint');
            }
            update() {
                var _a;
                const dataQuery = this.getDataQuery();
                const datasetRefs = dashboards.getDatasetRefsInDataQuery(dataQuery);
                const originalFilters = this.getValue();
                if (originalFilters) {
                    const { cleanedNode, wasModified } = this.validateAndCleanFiltersRecurse(originalFilters, datasetRefs);
                    if (wasModified) {
                        this.setValue(cleanedNode);
                        return;
                    }
                }
                const filters = originalFilters || { groupOperator: 'AND', groupConditions: [] };
                if (this.rootGroupEditor)
                    this.rootGroupEditor.update(filters, datasetRefs);
                else {
                    const isRoot = true;
                    const onChange = (newFilters) => this.setValue(newFilters);
                    const onDelete = () => this.setValue(null);
                    this.rootGroupEditor = new FilterGroupEditor(this.$editor, filters, datasetRefs, onChange, onDelete, isRoot);
                }
                appn.select.initForDesign({
                    elements: this.$editor.find('select'),
                    omitWidth: true,
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
                if (this.$multiCriteriaHint.length > 0) {
                    const criteriaCount = ((_a = filters.groupConditions) === null || _a === void 0 ? void 0 : _a.length) || 0;
                    this.$multiCriteriaHint.toggle(criteriaCount >= 2);
                }
            }
            bindEvents() { }
            destroy() {
                var _a;
                (_a = this.rootGroupEditor) === null || _a === void 0 ? void 0 : _a.destroy();
                this.rootGroupEditor = null;
                super.destroy();
            }
            validateAndCleanFiltersRecurse(node, datasetRefs) {
                var _a;
                if (!node)
                    return { cleanedNode: null, wasModified: false };
                let wasModified = false;
                let cleanedNode = appn.utils.deepClone(node);
                if (appn.utils.hasValue(cleanedNode.datasetIndex) && cleanedNode.columnId !== undefined) {
                    const datasetRef = datasetRefs[cleanedNode.datasetIndex];
                    const dataset = datasetRef ? dashboards.designer.getDatasets().find(t => t.id === datasetRef.id) : null;
                    const columnMeta = dataset === null || dataset === void 0 ? void 0 : dataset.columns.find(c => c.id === cleanedNode.columnId);
                    const columnType = (_a = columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.type) !== null && _a !== void 0 ? _a : null;
                    if (!columnMeta || !columnType) {
                        return { cleanedNode: cleanedNode, wasModified: false };
                    }
                    const beforeClean = JSON.stringify(cleanedNode);
                    cleanedNode = FilterCriterionEditor.cleanFilterCriterion(cleanedNode, columnType);
                    const afterClean = JSON.stringify(cleanedNode);
                    wasModified = beforeClean !== afterClean;
                }
                else if (cleanedNode.groupConditions) {
                    let childWasModified = false;
                    const newConditions = [];
                    for (const condition of cleanedNode.groupConditions) {
                        const result = this.validateAndCleanFiltersRecurse(condition, datasetRefs);
                        if (result.cleanedNode)
                            newConditions.push(result.cleanedNode);
                        else
                            childWasModified = true;
                        if (result.wasModified)
                            childWasModified = true;
                    }
                    if (childWasModified || newConditions.length !== cleanedNode.groupConditions.length) {
                        cleanedNode.groupConditions = newConditions;
                        wasModified = true;
                    }
                }
                else {
                    return { cleanedNode: cleanedNode, wasModified: false };
                }
                return { cleanedNode: cleanedNode, wasModified: wasModified };
            }
        }
        class AggregationFilterCriterionValueEditor {
            constructor(container, onValueChanged) {
                this.valueType = 'static';
                this.hasLoadedValueType = false;
                this.$root = appn.utils.cloneTemplate('editor-aggregationFilterCriterionValue');
                container.append(this.$root);
                this.onValueChanged = onValueChanged;
                this.context = {
                    currentColumnType: null,
                    aggregation: null,
                    datasetRefs: [],
                    value: undefined,
                    dynamicValue: undefined,
                    valueColumn: undefined,
                    valueMetricIndex: undefined,
                    operator: undefined,
                    globalFilterId: undefined
                };
                this.$staticGroup = this.$root.find('.value-static-group');
                this.$dynamicGroup = this.$root.find('.value-dynamic-group');
                this.$columnGroup = this.$root.find('.value-column-group');
                this.$globalFilterGroup = this.$root.find('.value-globalfilter-group');
                this.$valueText = this.$root.find('.filterValueText');
                this.$valueNumeric = this.$root.find('.filterValueNumeric');
                this.$valueDate = this.$root.find('.filterValueDate');
                this.$dynamicInput = this.$root.find('.filterDynamicValue');
                this.$columnSelect = this.$root.find('.filterValueColumnSelect');
                this.$globalFilterSelect = this.$root.find('.filterGlobalFilterSelect');
                this.initValueTypeSelects();
                this.initDatePicker();
                this.bindEvents();
            }
            get datePicker() {
                return this.$valueDate.data('DateTimePicker') || null;
            }
            initDatePicker() {
                appn.ui.dateTimePicker(this.$valueDate, () => this.onDatePickerChanged());
                const picker = this.datePicker;
                if (picker)
                    picker.useCurrent('day');
            }
            onDatePickerChanged() {
                var _a;
                const selectedMoment = (_a = this.datePicker) === null || _a === void 0 ? void 0 : _a.date();
                let finalValue;
                if (selectedMoment && (typeof selectedMoment.isValid === 'function' ? selectedMoment.isValid() : selectedMoment))
                    finalValue = selectedMoment.format('YYYY-MM-DDTHH:mm:ss') + 'Z';
                this.context.value = finalValue;
                this.onValueChanged({ value: finalValue });
            }
            setDatePickerValue(value) {
                var _a;
                const picker = this.datePicker;
                if (!picker) {
                    this.$valueDate.val((_a = value === null || value === void 0 ? void 0 : value.trim()) !== null && _a !== void 0 ? _a : '');
                    return;
                }
                const dateVal = value === null || value === void 0 ? void 0 : value.trim();
                if (!dateVal) {
                    picker.clear();
                    return;
                }
                const parsed = window.moment.utc(dateVal);
                if (parsed.isValid())
                    picker.date(parsed);
                else
                    picker.clear();
            }
            update(context) {
                this.context = context;
                if (!this.hasLoadedValueType) {
                    if (this.context.globalFilterId)
                        this.valueType = 'globalFilter';
                    else if (this.context.valueColumn != null || this.context.valueMetricIndex != null)
                        this.valueType = 'column';
                    else if (this.context.dynamicValue)
                        this.valueType = 'dynamic';
                    else
                        this.valueType = 'static';
                    this.hasLoadedValueType = true;
                }
                this.renderUI();
            }
            show() {
                this.$root.show();
            }
            hide() {
                this.$root.hide();
            }
            renderUI() {
                this.$root.find('.valueTypeSelect')
                    .val(this.valueType)
                    .trigger('change.select2');
                this.$staticGroup.toggle(this.valueType === 'static');
                this.$dynamicGroup.toggle(this.valueType === 'dynamic');
                this.$columnGroup.toggle(this.valueType === 'column');
                this.$globalFilterGroup.toggle(this.valueType === 'globalFilter');
                this.$valueText.hide();
                this.$valueNumeric.hide();
                this.$valueDate.hide();
                if (this.valueType === 'globalFilter')
                    this.populateGlobalFilterSelect();
                else if (this.valueType === 'static') {
                    const columnType = this.context.currentColumnType;
                    let $input;
                    if (columnType === 'Number')
                        $input = this.$valueNumeric;
                    else if (columnType === 'Date')
                        $input = this.$valueDate;
                    else
                        $input = this.$valueText;
                    $input.show();
                    const value = this.context.value;
                    if (columnType === 'Date')
                        this.setDatePickerValue(value || '');
                    else
                        $input.val(value || '');
                }
                else if (this.valueType === 'dynamic')
                    this.$dynamicInput.val(this.context.dynamicValue || '');
                else if (this.valueType === 'column')
                    this.populateColumnSelect();
            }
            populateColumnSelect() {
                const aggregation = this.context.aggregation;
                const datasetRefs = this.context.datasetRefs;
                const datasets = dashboards.designer.getDatasets();
                this.$columnSelect.empty().append('<option value="">Choose column...</option>');
                if (!aggregation)
                    return;
                const { groupBy, breakDownBy, metrics } = aggregation;
                const groups = [];
                const showPrefix = datasetRefs.length > 1;
                const getGroupLabelAndMeta = (colIdentifier, source) => {
                    if (!colIdentifier)
                        return null;
                    const { datasetRef, dataset, columnMeta } = dashboards.getContextualColumnMeta(colIdentifier.datasetIndex, colIdentifier.columnId, datasetRefs, datasets);
                    if (!datasetRef || !dataset || !columnMeta)
                        return null;
                    const datasetPrefix = datasetRef.alias || dataset.name;
                    const columnText = dashboards.getColumnOptionText(columnMeta);
                    const label = showPrefix ? `${datasetPrefix}.${columnText}` : columnText;
                    const value = `${source}`;
                    return { label, value, type: columnMeta.type };
                };
                const groupByMeta = getGroupLabelAndMeta(groupBy, 'group');
                if (groupByMeta)
                    groups.push(groupByMeta);
                const breakDownByMeta = getGroupLabelAndMeta(breakDownBy, 'breakdown');
                if (breakDownByMeta)
                    groups.push(breakDownByMeta);
                if (groups.length > 0) {
                    const $optgroup = $('<optgroup label="Groups"></optgroup>');
                    groups.forEach(g => $optgroup.append($('<option>').val(g.value).text(g.label)));
                    this.$columnSelect.append($optgroup);
                }
                if (metrics && metrics.length > 0) {
                    const $optgroup = $('<optgroup label="Metrics"></optgroup>');
                    metrics.forEach((m, index) => {
                        const value = `metric|${index}`;
                        const text = dashboards.getMetricDisplayText(m, index, aggregation, datasetRefs, datasets);
                        $optgroup.append($('<option>').val(value).text(text));
                    });
                    this.$columnSelect.append($optgroup);
                }
                let currentValue = '';
                if (this.context.valueColumn != null) {
                    if (groupBy && groupBy.datasetIndex === this.context.valueColumn.datasetIndex && groupBy.columnId === this.context.valueColumn.columnId)
                        currentValue = 'group';
                    else if (breakDownBy && breakDownBy.datasetIndex === this.context.valueColumn.datasetIndex && breakDownBy.columnId === this.context.valueColumn.columnId)
                        currentValue = 'breakdown';
                }
                else if (this.context.valueMetricIndex != null)
                    currentValue = `metric|${this.context.valueMetricIndex}`;
                this.$columnSelect.val(currentValue);
                appn.select.initForDesign({
                    elements: this.$columnSelect,
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
            }
            initValueTypeSelects() {
                appn.select.initForDesign({
                    elements: this.$root.find('.valueTypeSelect'),
                    isIconButtonSelect: true,
                    omitWidth: true
                });
                this.$root.find('.valueTypeSelect').on('select2:select', (e) => {
                    const newType = e.params.data.id;
                    if (newType !== this.valueType) {
                        this.valueType = newType;
                        this.renderUI();
                    }
                });
            }
            openFormulaBuilder() {
                var _a, _b;
                const currentValue = this.context.dynamicValue;
                appn.ui.formulabuilder.controlName = 'FilterValue';
                appn.ui.formulabuilder.$input = this.$dynamicInput;
                appn.ui.formulabuilder.currentFormula = currentValue || '';
                appn.ui.formulabuilder.currentMode = (_b = (_a = appn.designerv2) === null || _a === void 0 ? void 0 : _a.FormulaType) === null || _b === void 0 ? void 0 : _b.normal;
                appn.ui.formulabuilder.isFormula = true;
                appn.ui.formulabuilder.formulaUpdated = (formula) => {
                    this.$dynamicInput.val(formula).trigger('input');
                };
                appn.ui.formulabuilder.showDialog();
            }
            bindEvents() {
                this.$root.on('input change', '.filterValueText, .filterValueNumeric', (e) => {
                    const target = $(e.currentTarget);
                    let rawValue = target.val();
                    let finalValue;
                    if (!rawValue || rawValue === '')
                        finalValue = undefined;
                    else
                        finalValue = rawValue;
                    this.context.value = finalValue;
                    this.onValueChanged({ value: finalValue });
                });
                this.$root.on('change', '.filterDynamicValue', (e) => {
                    const val = $(e.target).val();
                    this.context.dynamicValue = val || undefined;
                    this.onValueChanged({ dynamicValue: val || undefined });
                });
                this.$root.on('click', '.buildDynamicIcon', (e) => {
                    e.preventDefault();
                    this.openFormulaBuilder();
                });
                this.$root.on('change', '.filterValueColumnSelect', (e) => {
                    const val = $(e.target).val();
                    const aggregation = this.context.aggregation;
                    if (val) {
                        if (val === 'group' && (aggregation === null || aggregation === void 0 ? void 0 : aggregation.groupBy)) {
                            this.context.valueColumn = { datasetIndex: aggregation.groupBy.datasetIndex, columnId: aggregation.groupBy.columnId };
                            this.context.valueMetricIndex = undefined;
                            this.onValueChanged({ valueColumn: this.context.valueColumn, valueMetricIndex: undefined });
                        }
                        else if (val === 'breakdown' && (aggregation === null || aggregation === void 0 ? void 0 : aggregation.breakDownBy)) {
                            this.context.valueColumn = { datasetIndex: aggregation.breakDownBy.datasetIndex, columnId: aggregation.breakDownBy.columnId };
                            this.context.valueMetricIndex = undefined;
                            this.onValueChanged({ valueColumn: this.context.valueColumn, valueMetricIndex: undefined });
                        }
                        else if (val.startsWith('metric|')) {
                            const index = parseInt(val.split('|')[1], 10);
                            this.context.valueColumn = undefined;
                            this.context.valueMetricIndex = index;
                            this.onValueChanged({ valueColumn: undefined, valueMetricIndex: index });
                        }
                    }
                    else {
                        this.context.valueColumn = undefined;
                        this.context.valueMetricIndex = undefined;
                        this.onValueChanged({ valueColumn: undefined, valueMetricIndex: undefined });
                    }
                });
                this.$root.on('change', '.filterGlobalFilterSelect', (e) => {
                    const val = $(e.target).val();
                    this.context.globalFilterId = val || undefined;
                    this.onValueChanged({ globalFilterId: val || undefined });
                });
            }
            populateGlobalFilterSelect() {
                const compatible = getGlobalFiltersForValueType(this.context.operator, true);
                const current = this.context.globalFilterId || '';
                this.$globalFilterSelect.empty().append(`<option value="">${T('Choose global filter')}...</option>`);
                compatible.forEach(f => this.$globalFilterSelect.append($('<option>').val(f.id).text(f.label || f.id)));
                appn.select.initForDesign({
                    elements: this.$globalFilterSelect.not('.select2-hidden-accessible'),
                    omitWidth: true,
                    minimumResultsForSearch: '10'
                });
                this.$globalFilterSelect.val(compatible.some(f => f.id === current) ? current : '')
                    .trigger('change.select2');
            }
            destroy() {
                this.$root.remove();
            }
        }
        class AggregationFilterCriterionEditor {
            constructor(container, criterion, aggregation, datasetRefs, onChanged, onDelete) {
                this.valueEditor1 = null;
                this.valueEditor2 = null;
                this.availableColumns = [];
                this.currentColumnType = null;
                this.$filterCriterionRow = appn.utils.cloneTemplate('editor-filterCriterionRow');
                container.append(this.$filterCriterionRow);
                this.criterion = criterion;
                this.aggregation = aggregation;
                this.datasetRefs = datasetRefs;
                this.onChanged = onChanged;
                this.onDelete = onDelete;
                this.$column = this.$filterCriterionRow.find('.filterColumnSelect');
                this.$operator = this.$filterCriterionRow.find('.filterOperatorSelect');
                this.$removeCriterion = this.$filterCriterionRow.find('.removeBtn');
                this.$allOperatorOptions = this.$operator.find('option').clone();
                this.$valueArea = this.$filterCriterionRow.find('.value-input-area');
                this.$valuePlaceholder = this.$valueArea.find('.filterValuePlaceholder');
                this.$value1Container = this.$valueArea.find('.value1-input-container');
                this.$value2Row = this.$filterCriterionRow.find('.value2-row');
                this.$valueSeparator = this.$value2Row.find('.value-separator');
                this.$value2Container = this.$value2Row.find('.value2-input-container');
                this.update(criterion, aggregation, datasetRefs);
                this.bindEvents();
            }
            update(criterion, aggregation, datasetRefs, onChanged) {
                if (onChanged)
                    this.onChanged = onChanged;
                this.criterion = criterion;
                this.aggregation = aggregation;
                this.datasetRefs = datasetRefs;
                const selectedValue = (appn.utils.hasValue(this.criterion.metricIndex) ? `metric|${this.criterion.metricIndex}` : null)
                    || (this.criterion.column && appn.utils.hasValue(this.criterion.column.datasetIndex) ? `col|${this.criterion.column.datasetIndex}|${this.criterion.column.columnId}` : '');
                this.populateColumns();
                this.$column.val(selectedValue);
                this.updateCurrentColumnType(selectedValue);
                this.populateOperators();
                this.$operator.val(this.criterion.operator || 'Equals');
                this.updateValueInputsVisibilityAndValues();
                this.$filterCriterionRow.toggleClass('filter-criterion-global', !!this.criterion.globalFilterId);
            }
            showDeleteButton(visible) {
                this.$removeCriterion.toggle(visible);
            }
            populateColumns() {
                const datasets = dashboards.designer.getDatasets();
                this.availableColumns = [];
                this.$column.empty().append($('<option>').val('').text('Choose column...'));
                if (!this.aggregation)
                    return;
                const { groupBy, breakDownBy, metrics } = this.aggregation;
                const groups = [];
                const showPrefix = this.datasetRefs.length > 1;
                const getGroupLabelAndMeta = (colIdentifier, source) => {
                    if (!colIdentifier)
                        return null;
                    const { datasetRef, dataset, columnMeta } = dashboards.getContextualColumnMeta(colIdentifier.datasetIndex, colIdentifier.columnId, this.datasetRefs, datasets);
                    if (!datasetRef || !dataset || !columnMeta)
                        return null;
                    const datasetPrefix = datasetRef.alias || dataset.name;
                    const columnText = dashboards.getColumnOptionText(columnMeta);
                    const label = showPrefix ? `${datasetPrefix}.${columnText}` : columnText;
                    const value = `col|${colIdentifier.datasetIndex}|${colIdentifier.columnId}`;
                    this.availableColumns.push({ id: value, name: label, type: columnMeta.type, source: source });
                    return { label, value, type: columnMeta.type };
                };
                const groupByMeta = getGroupLabelAndMeta(groupBy, 'group');
                if (groupByMeta)
                    groups.push(groupByMeta);
                const breakDownByMeta = getGroupLabelAndMeta(breakDownBy, 'breakdown');
                if (breakDownByMeta)
                    groups.push(breakDownByMeta);
                if (groups.length > 0) {
                    const $optgroup = $('<optgroup label="Groups"></optgroup>');
                    groups.forEach(g => $optgroup.append($('<option>').val(g.value).text(g.label)));
                    this.$column.append($optgroup);
                }
                if (metrics && metrics.length > 0) {
                    const $optgroup = $('<optgroup label="Metrics"></optgroup>');
                    metrics.forEach((m, index) => {
                        const value = `metric|${index}`;
                        const text = dashboards.getMetricDisplayText(m, index, this.aggregation, this.datasetRefs, datasets);
                        $optgroup.append($('<option>').val(value).text(text));
                        this.availableColumns.push({ id: value, name: text, type: 'Number', source: 'metric' });
                    });
                    this.$column.append($optgroup);
                }
            }
            updateCurrentColumnType(selectedValue) {
                if (!selectedValue) {
                    this.currentColumnType = null;
                    return;
                }
                const col = this.availableColumns.find(c => c.id === selectedValue);
                this.currentColumnType = col ? col.type : null;
            }
            populateOperators() {
                const currentOperator = this.$operator.val();
                this.$operator.empty();
                const operators = this.$allOperatorOptions.clone();
                operators.each((_, opt) => {
                    const $opt = $(opt);
                    const opValue = $opt.val();
                    const req = AggregationFilterCriterionEditor.operatorRequirements[opValue];
                    if (this.currentColumnType && req && req.types.includes(this.currentColumnType))
                        this.$operator.append($opt);
                    else if (!this.currentColumnType)
                        this.$operator.append($opt);
                });
                if (this.$operator.find(`option[value="${currentOperator}"]`).length > 0)
                    this.$operator.val(currentOperator);
                else
                    this.$operator.val('Equals');
            }
            updateValueInputsVisibilityAndValues() {
                const operator = this.$operator.val();
                const req = AggregationFilterCriterionEditor.operatorRequirements[operator];
                const valuesNeeded = this.criterion.globalFilterId ? 1 : (req ? req.values : 0);
                this.$valuePlaceholder.hide();
                this.$value2Row.hide();
                this.$valueSeparator.hide();
                const createContextForValue1 = () => ({
                    currentColumnType: this.currentColumnType,
                    aggregation: this.aggregation,
                    datasetRefs: this.datasetRefs,
                    value: this.criterion.value,
                    dynamicValue: this.criterion.dynamicValue,
                    valueColumn: this.criterion.valueColumn,
                    valueMetricIndex: this.criterion.valueMetricIndex,
                    operator: this.criterion.operator,
                    globalFilterId: this.criterion.globalFilterId
                });
                const createContextForValue2 = () => ({
                    currentColumnType: this.currentColumnType,
                    aggregation: this.aggregation,
                    datasetRefs: this.datasetRefs,
                    value: this.criterion.value2,
                    dynamicValue: this.criterion.dynamicValue2,
                    valueColumn: this.criterion.value2Column,
                    valueMetricIndex: this.criterion.value2MetricIndex,
                    operator: this.criterion.operator,
                    globalFilterId: this.criterion.globalFilterId
                });
                if (valuesNeeded === 0) {
                    this.$valuePlaceholder.show();
                    if (this.valueEditor1)
                        this.valueEditor1.hide();
                    if (this.valueEditor2)
                        this.valueEditor2.hide();
                }
                else if (valuesNeeded >= 1) {
                    if (!this.valueEditor1) {
                        this.valueEditor1 = new AggregationFilterCriterionValueEditor(this.$value1Container, (updates) => {
                            this.criterion = Object.assign(Object.assign({}, this.criterion), { value: updates.value, dynamicValue: updates.dynamicValue, valueColumn: updates.valueColumn, valueMetricIndex: updates.valueMetricIndex, globalFilterId: updates.globalFilterId });
                            this.onChanged(this.criterion);
                        });
                    }
                    this.valueEditor1.update(createContextForValue1());
                    this.valueEditor1.show();
                }
                if (valuesNeeded === 2) {
                    this.$value2Row.show();
                    this.$valueSeparator.show();
                    if (!this.valueEditor2) {
                        this.valueEditor2 = new AggregationFilterCriterionValueEditor(this.$value2Container, (updates) => {
                            this.criterion = Object.assign(Object.assign({}, this.criterion), { value2: updates.value, dynamicValue2: updates.dynamicValue, value2Column: updates.valueColumn, value2MetricIndex: updates.valueMetricIndex });
                            this.onChanged(this.criterion);
                        });
                    }
                    this.valueEditor2.update(createContextForValue2());
                    this.valueEditor2.show();
                }
            }
            bindEvents() {
                this.$filterCriterionRow.on('click', '.removeBtn', () => this.onDelete());
                this.$filterCriterionRow.on('change', '.filterColumnSelect', e => {
                    this.criterion = Object.assign(Object.assign({}, this.criterion), { column: undefined, metricIndex: undefined });
                    const val = $(e.target).val();
                    if (val) {
                        const parts = val.split('|');
                        if (parts[0] === 'metric')
                            this.criterion.metricIndex = parseInt(parts[1], 10);
                        else if (parts[0] === 'col')
                            this.criterion.column = { datasetIndex: parseInt(parts[1], 10), columnId: parts[2] };
                    }
                    this.updateCurrentColumnType(val);
                    this.populateOperators();
                    this.criterion.operator = this.$operator.val();
                    this.criterion.value = undefined;
                    this.criterion.value2 = undefined;
                    this.criterion.dynamicValue = undefined;
                    this.criterion.dynamicValue2 = undefined;
                    this.criterion.valueColumn = undefined;
                    this.criterion.valueMetricIndex = undefined;
                    this.criterion.value2Column = undefined;
                    this.criterion.value2MetricIndex = undefined;
                    this.onChanged(this.criterion);
                });
                this.$filterCriterionRow.on('change', '.filterOperatorSelect', e => {
                    const newOperator = $(e.target).val();
                    if (this.criterion.globalFilterId && !(GLOBAL_FILTER_TYPES_BY_OPERATOR[newOperator] || []).includes(dashboards.DashboardGlobalFilterType.NumberRange))
                        this.criterion = Object.assign(Object.assign({}, this.criterion), { globalFilterId: undefined });
                    this.criterion = Object.assign(Object.assign({}, this.criterion), { operator: newOperator });
                    const req = AggregationFilterCriterionEditor.operatorRequirements[newOperator];
                    const valuesNeeded = req ? req.values : 0;
                    if (valuesNeeded < 1) {
                        this.criterion.value = undefined;
                        this.criterion.dynamicValue = undefined;
                        this.criterion.valueColumn = undefined;
                        this.criterion.valueMetricIndex = undefined;
                    }
                    if (valuesNeeded < 2) {
                        this.criterion.value2 = undefined;
                        this.criterion.dynamicValue2 = undefined;
                        this.criterion.value2Column = undefined;
                        this.criterion.value2MetricIndex = undefined;
                    }
                    this.onChanged(this.criterion);
                });
            }
            destroy() {
                var _a, _b;
                (_a = this.valueEditor1) === null || _a === void 0 ? void 0 : _a.destroy();
                (_b = this.valueEditor2) === null || _b === void 0 ? void 0 : _b.destroy();
                this.$filterCriterionRow.remove();
            }
        }
        AggregationFilterCriterionEditor.operatorRequirements = FilterCriterionEditor.operatorRequirements;
        class AggregationFilterGroupEditor {
            constructor(container, filterGroup, aggregation, datasetRefs, onChanged, onDelete, isRoot = false) {
                this.childEditors = [];
                this.$filterGroup = isRoot ?
                    container : appn.utils.cloneTemplate('editor-filterGroup');
                if (!isRoot)
                    container.append(this.$filterGroup);
                this.isRoot = isRoot;
                this.filterGroup = filterGroup;
                this.aggregation = aggregation;
                this.datasetRefs = datasetRefs;
                this.onChanged = onChanged;
                this.onDelete = onDelete;
                this.operationSelector = isRoot ? '.filterLogicalOperator' : '.groupLogicalOperator';
                this.$operation = this.$filterGroup.find(this.operationSelector);
                this.$conditions = this.$filterGroup.find('.filterConditionsList');
                this.$removeGroup = this.$filterGroup.find('.removeGroupBtn');
                this.update(filterGroup, aggregation, datasetRefs);
                this.bindEvents();
            }
            update(filterGroup, aggregation, datasetRefs, onChanged, onDelete) {
                var _a;
                if (onChanged)
                    this.onChanged = onChanged;
                if (onDelete)
                    this.onDelete = onDelete;
                this.filterGroup = filterGroup;
                this.aggregation = aggregation;
                this.datasetRefs = datasetRefs;
                this.$operation.val(this.filterGroup.groupOperator || 'AND');
                const newConditions = this.filterGroup.groupConditions || [];
                while (this.childEditors.length > newConditions.length)
                    (_a = this.childEditors.pop()) === null || _a === void 0 ? void 0 : _a.destroy();
                const canDeleteChildren = this.isRoot || newConditions.length > 2;
                newConditions.forEach((condition, index) => {
                    const onChildChanged = (newChildData) => {
                        this.filterGroup = appn.utils.deepClone(this.filterGroup);
                        this.filterGroup.groupConditions[index] = newChildData;
                        this.onChanged(this.filterGroup);
                    };
                    const onChildDeleted = () => {
                        this.filterGroup = appn.utils.deepClone(this.filterGroup);
                        this.filterGroup.groupConditions.splice(index, 1);
                        if (this.isRoot && this.filterGroup.groupConditions.length === 0)
                            this.onDelete();
                        else
                            this.onChanged(this.filterGroup);
                    };
                    const existingEditor = this.childEditors[index];
                    const isGroup = !!condition.groupConditions;
                    const typeMatches = existingEditor
                        && ((isGroup && existingEditor instanceof AggregationFilterGroupEditor)
                            || (!isGroup && existingEditor instanceof AggregationFilterCriterionEditor));
                    if (typeMatches) {
                        existingEditor.update(condition, this.aggregation, this.datasetRefs, onChildChanged, onChildDeleted);
                    }
                    else {
                        if (existingEditor)
                            existingEditor.destroy();
                        const $listItem = $('<li></li>');
                        this.$conditions.append($listItem);
                        if (isGroup) {
                            $listItem.addClass('mt-2');
                            this.childEditors[index] = new AggregationFilterGroupEditor($listItem, condition, this.aggregation, this.datasetRefs, onChildChanged, onChildDeleted);
                        }
                        else
                            this.childEditors[index] = new AggregationFilterCriterionEditor($listItem, condition, this.aggregation, this.datasetRefs, onChildChanged, onChildDeleted);
                    }
                    const editor = this.childEditors[index];
                    if (editor)
                        editor.showDeleteButton(canDeleteChildren);
                });
            }
            showDeleteButton(visible) {
                this.$removeGroup.toggle(visible);
            }
            bindEvents() {
                const $removeEle = this.$filterGroup.parent().is('li') ? this.$filterGroup.parent() : this.$filterGroup;
                $removeEle.on('click', '.removeGroupBtn', (e) => {
                    e.stopPropagation();
                    this.onDelete();
                });
                this.$filterGroup.on('change', this.operationSelector, e => {
                    this.filterGroup = Object.assign(Object.assign({}, this.filterGroup), { groupOperator: $(e.target).val() });
                    this.onChanged(this.filterGroup);
                });
                this.$filterGroup.on('click', '.addCriterionToGroupBtn, .addFilterCriterion', (e) => {
                    e.stopPropagation();
                    this.addCondition(false);
                });
                this.$filterGroup.on('click', '.addGroupToGroupBtn, .addFilterGroup', (e) => {
                    e.stopPropagation();
                    this.addCondition(true);
                });
            }
            addCondition(isGroup) {
                this.filterGroup = appn.utils.deepClone(this.filterGroup);
                if (!this.filterGroup.groupConditions)
                    this.filterGroup.groupConditions = [];
                if (isGroup) {
                    this.filterGroup.groupConditions.push({
                        groupOperator: 'OR',
                        groupConditions: [
                            { operator: 'Equals' },
                            { operator: 'Equals' }
                        ]
                    });
                }
                else {
                    this.filterGroup.groupConditions.push({ operator: 'Equals' });
                }
                this.onChanged(this.filterGroup);
            }
            destroy() {
                this.childEditors.forEach(c => c.destroy());
                this.childEditors = [];
                if (!this.$filterGroup.parent().is('li'))
                    this.$filterGroup.remove();
                else
                    this.$filterGroup.parent().remove();
            }
        }
        class AggregationFiltersEditor extends DataQueryEditorBase {
            constructor() {
                super(...arguments);
                this.rootGroupEditor = null;
            }
            init() {
                this.$multiCriteriaHint = this.$editor.find('.filterMultiCriteriaHint');
            }
            update() {
                var _a;
                const dataQuery = this.getDataQuery();
                const datasetRefs = dashboards.getDatasetRefsInDataQuery(dataQuery);
                const aggregation = dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.aggregation;
                const originalFilters = this.getValue();
                const filters = originalFilters || { groupOperator: 'AND', groupConditions: [] };
                if (this.rootGroupEditor) {
                    this.rootGroupEditor.update(filters, aggregation, datasetRefs);
                }
                else {
                    const isRoot = true;
                    const onChange = (newFilters) => this.setValue(newFilters);
                    const onDelete = () => this.setValue(null);
                    this.rootGroupEditor = new AggregationFilterGroupEditor(this.$editor, filters, aggregation, datasetRefs, onChange, onDelete, isRoot);
                }
                appn.select.initForDesign({
                    elements: this.$editor.find('select'),
                    omitWidth: true,
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
                if (this.$multiCriteriaHint.length > 0) {
                    const criteriaCount = ((_a = filters.groupConditions) === null || _a === void 0 ? void 0 : _a.length) || 0;
                    this.$multiCriteriaHint.toggle(criteriaCount >= 2);
                }
            }
            bindEvents() {
                this.subscribeToEvent(dashboards.DASH_EVENTS.ALIAS_CHANGED, (payload) => {
                    if (payload.componentId === this.component.id)
                        this.update();
                });
                this.subscribeToEvent(dashboards.DASH_EVENTS.METRIC_REMOVED, (payload) => {
                    if (payload.componentId !== this.component.id)
                        return;
                    const rootFilter = this.getValueForEdit();
                    if (!rootFilter)
                        return;
                    const removedIndex = payload.removedIndex;
                    let wasChanged = false;
                    const updateIndicesRecurse = (filter) => {
                        if (filter.groupConditions) {
                            filter.groupConditions.forEach(updateIndicesRecurse);
                        }
                        else if (appn.utils.hasValue(filter.metricIndex)) {
                            const refIndex = filter.metricIndex;
                            if (refIndex === removedIndex) {
                                filter.metricIndex = undefined;
                                wasChanged = true;
                            }
                            else if (refIndex > removedIndex) {
                                filter.metricIndex--;
                                wasChanged = true;
                            }
                        }
                    };
                    updateIndicesRecurse(rootFilter);
                    if (wasChanged)
                        this.setValue(rootFilter);
                });
            }
            destroy() {
                var _a;
                (_a = this.rootGroupEditor) === null || _a === void 0 ? void 0 : _a.destroy();
                this.rootGroupEditor = null;
                super.destroy();
            }
        }
        class ProjectionRowEditor {
            constructor(container, projection, datasetRefs, onChanged, onDelete) {
                this.$projectionRow = appn.utils.cloneTemplate('editor-projectionRow');
                container.append(this.$projectionRow);
                this.projection = projection;
                this.aliasedDatasets = datasetRefs;
                this.onChanged = onChanged;
                this.onDelete = onDelete;
                this.$column = this.$projectionRow.find('.projection-column-select');
                this.$alias = this.$projectionRow.find('.projection-alias-input');
                this.update(projection, datasetRefs);
                this.bindEvents();
            }
            update(projection, datasetRefs) {
                this.projection = projection;
                this.aliasedDatasets = datasetRefs;
                const selectedValue = appn.utils.hasValue(this.projection.datasetIndex) && this.projection.columnId ? `${this.projection.datasetIndex}|${this.projection.columnId}` : '';
                dashboards.populatePrefixedColumnSelect(this.$column, this.aliasedDatasets, null, selectedValue);
                this.$alias.val(this.projection.alias || '');
            }
            bindEvents() {
                this.$projectionRow.on('click', '.remove-projection', () => this.onDelete());
                this.$projectionRow.on('change', '.projection-column-select', e => {
                    const val = $(e.target).val();
                    if (val) {
                        const [datasetIndexStr, columnId] = val.split('|');
                        this.onChanged(Object.assign(Object.assign({}, this.projection), { datasetIndex: parseInt(datasetIndexStr, 10), columnId }));
                    }
                });
                this.$projectionRow.on('input', '.projection-alias-input', e => {
                    this.projection.alias = $(e.target).val();
                    this.onChanged(this.projection);
                });
                this.$projectionRow.on('change', '.projection-alias-input', e => {
                    this.projection.alias = $(e.target).val();
                    this.onChanged(this.projection);
                });
            }
            destroy() {
                this.$projectionRow.remove();
            }
        }
        class ProjectionSelectorEditor extends DataQueryEditorBase {
            constructor() {
                super(...arguments);
                this.projectionEditors = [];
            }
            init() {
                this.$projectionsList = this.$editor.find('.projections-list');
            }
            update() {
                var _a, _b;
                const dataQuery = this.getDataQuery();
                const datasetRefs = dashboards.getDatasetRefsInDataQuery(dataQuery);
                const projections = ((_a = this.getValue()) === null || _a === void 0 ? void 0 : _a.columns) || [];
                while (this.projectionEditors.length > projections.length)
                    (_b = this.projectionEditors.pop()) === null || _b === void 0 ? void 0 : _b.destroy();
                projections.forEach((proj, index) => {
                    if (this.projectionEditors.length <= index) {
                        const onChange = (newProjection) => {
                            const currentProjections = this.getValueForEdit() || { columns: [] };
                            currentProjections.columns[index] = newProjection;
                            this.setValue(currentProjections);
                        };
                        const onDelete = () => {
                            const currentProjection = this.getValueForEdit() || { columns: [] };
                            currentProjection.columns.splice(index, 1);
                            this.setValue(currentProjection.columns.length === 0 ? null : currentProjection);
                        };
                        const editor = new ProjectionRowEditor(this.$projectionsList, proj, datasetRefs, onChange, onDelete);
                        this.projectionEditors.push(editor);
                    }
                    else
                        this.projectionEditors[index].update(proj, datasetRefs);
                });
                appn.select.initForDesign({
                    elements: this.$editor.find('select'),
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
            }
            bindEvents() {
                this.$editor.on('click', '.add-projection', () => {
                    const projections = this.getValueForEdit() || { columns: [] };
                    projections.columns.push({ datasetIndex: 0, columnId: '' });
                    this.setValue(projections);
                });
            }
            destroy() {
                this.projectionEditors.forEach(e => e.destroy());
                this.projectionEditors = [];
                super.destroy();
            }
        }
        class MetricRowEditor {
            constructor(container, metric, datasetRefs, onInput, onChanged, onDelete, isSingleMode) {
                this.$metricRow = appn.utils.cloneTemplate('editor-metricRow');
                container.append(this.$metricRow);
                this.metric = metric;
                this.datasetRefs = datasetRefs;
                this.onInput = onInput;
                this.onChanged = onChanged;
                this.onDelete = onDelete;
                this.isSingleMode = isSingleMode;
                this.$function = this.$metricRow.find('.metric-function');
                this.$column = this.$metricRow.find('.metric-column');
                this.$alias = this.$metricRow.find('.metric-alias');
                this.$removeButton = this.$metricRow.find('.remove-metric');
                this.update(metric, datasetRefs);
                this.bindEvents();
            }
            _updateColumnVisibility() {
                const func = this.$function.val();
                const $select = this.$metricRow.find('.metric-column-wrapper');
                const $placeholder = this.$metricRow.find('.metric-column-placeholder');
                if (func === 'Count') {
                    $select.hide();
                    $placeholder.show();
                }
                else {
                    $select.show();
                    $placeholder.hide();
                }
            }
            _getColumnFilter() {
                const func = this.$function.val();
                switch (func) {
                    case 'Avg':
                    case 'Sum':
                        return ['Number'];
                    case 'CountDistinct':
                    case 'Min':
                    case 'Max':
                        return null;
                    case 'Count':
                    default:
                        return null;
                }
            }
            update(metric, datasetRefs, metricsCount) {
                this.metric = metric;
                this.datasetRefs = datasetRefs;
                this.$function.val(this.metric.function);
                this.$alias.val(this.metric.alias);
                this.$alias.attr('placeholder', 'Alias (Optional)');
                const selectedValue = appn.utils.hasValue(this.metric.datasetIndex) && this.metric.columnId ? `${this.metric.datasetIndex}|${this.metric.columnId}` : '';
                const columnTypeFilter = this._getColumnFilter();
                dashboards.populatePrefixedColumnSelect(this.$column, this.datasetRefs, columnTypeFilter, selectedValue);
                this._updateColumnVisibility();
                const canDelete = !this.isSingleMode || (metricsCount && metricsCount > 1);
                this.$removeButton.toggle(canDelete);
            }
            bindEvents() {
                this.$metricRow.on('click', '.remove-metric', () => this.onDelete());
                this.$metricRow.on('change', '.metric-function', e => {
                    const newFunc = $(e.target).val();
                    this._updateColumnVisibility();
                    const newAlias = this.$alias.val();
                    if (newFunc === 'Count')
                        this.onChanged(Object.assign(Object.assign({}, this.metric), { function: newFunc, alias: newAlias, datasetIndex: 0, columnId: undefined }));
                    else
                        this.onChanged(Object.assign(Object.assign({}, this.metric), { function: newFunc, alias: newAlias }));
                });
                this.$metricRow.on('change', '.metric-column', e => {
                    const val = $(e.target).val();
                    let newData = Object.assign(Object.assign({}, this.metric), { alias: this.$alias.val() });
                    if (val) {
                        const [datasetIndexStr, columnId] = val.split('|');
                        newData.datasetIndex = parseInt(datasetIndexStr, 10);
                        newData.columnId = columnId;
                    }
                    else {
                        newData.datasetIndex = undefined;
                        newData.columnId = '';
                    }
                    this.onChanged(newData);
                });
                this.$alias.on('focus', e => $(e.target).data('old-alias', $(e.target).val()));
                this.$alias.on('input', e => {
                    this.metric.alias = $(e.target).val();
                    this.onInput(this.metric);
                });
                this.$alias.on('change', e => {
                    this.metric.alias = $(e.target).val();
                    this.onChanged(this.metric);
                });
            }
            destroy() {
                this.$metricRow.remove();
            }
        }
        class MetricsEditor extends DataQueryEditorBase {
            constructor() {
                super(...arguments);
                this.metricEditors = [];
            }
            init() {
                this.$metricsList = this.$editor.find('.metrics-list');
                this.$addMetric = this.$editor.find('.add-metric');
            }
            update() {
                var _a, _b, _c;
                const dataQuery = this.getDataQuery();
                const datasetRefs = dashboards.getDatasetRefsInDataQuery(dataQuery);
                const metrics = this.getValue() || [];
                const singleMode = (_b = (_a = this.propDef.config) === null || _a === void 0 ? void 0 : _a.single) !== null && _b !== void 0 ? _b : false;
                if (dataQuery && singleMode) {
                    if (metrics.length === 0 && this.isEditorVisible()) {
                        const currentMetrics = this.getValueForEdit() || [];
                        if (currentMetrics.length === 0) {
                            currentMetrics.push({
                                function: 'Count',
                                datasetIndex: 0,
                                columnId: undefined,
                                alias: ``
                            });
                            this.setValue(currentMetrics);
                            return;
                        }
                    }
                    else if (metrics.length == 1 && !this.isEditorVisible()) {
                        this.setValue([]);
                        return;
                    }
                }
                while (this.metricEditors.length > metrics.length)
                    (_c = this.metricEditors.pop()) === null || _c === void 0 ? void 0 : _c.destroy();
                metrics.forEach((metric, index) => {
                    if (this.metricEditors.length <= index) {
                        const onInput = (newMetricData) => {
                            const currentMetrics = this.getValueForEdit() || [];
                            const oldAlias = currentMetrics[index].alias;
                            currentMetrics[index] = newMetricData;
                            this.setValue(currentMetrics);
                            if (oldAlias !== newMetricData.alias) {
                                distill.eventBus.publish(dashboards.DASH_EVENTS.ALIAS_CHANGED, {
                                    componentId: this.component.id,
                                    oldAlias: oldAlias,
                                    newAlias: newMetricData.alias
                                });
                            }
                        };
                        const onChange = (newMetricData) => {
                            const rootDataQuery = this.getDataQuery();
                            const currentMetrics = this.getValueForEdit() || [];
                            const oldAlias = currentMetrics[index].alias;
                            newMetricData.alias = dashboards.runAggregationAliasDeduplication(rootDataQuery, newMetricData.alias, 'metric', index);
                            currentMetrics[index] = newMetricData;
                            this.setValue(currentMetrics);
                            if (oldAlias !== newMetricData.alias) {
                                distill.eventBus.publish(dashboards.DASH_EVENTS.ALIAS_CHANGED, {
                                    componentId: this.component.id,
                                    oldAlias: oldAlias,
                                    newAlias: newMetricData.alias
                                });
                            }
                        };
                        const onDelete = () => {
                            const currentMetrics = this.getValueForEdit() || [];
                            currentMetrics.splice(index, 1);
                            this.setValue(currentMetrics);
                            distill.eventBus.publish(dashboards.DASH_EVENTS.METRIC_REMOVED, { componentId: this.component.id, removedIndex: index });
                        };
                        const editor = new MetricRowEditor(this.$metricsList, metric, datasetRefs, onInput, onChange, onDelete, singleMode);
                        this.metricEditors.push(editor);
                    }
                    else
                        this.metricEditors[index].update(metric, datasetRefs, metrics.length);
                });
                this.$addMetric.toggle(!singleMode || metrics.length === 0);
                appn.select.initForDesign({
                    elements: this.$editor.find('select'),
                    omitWidth: true,
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
            }
            bindEvents() {
                this.subscribeToEvent(dashboards.DASH_EVENTS.ALIAS_CHANGED, (payload) => {
                    if (payload.componentId === this.component.id)
                        this.update();
                });
                this.$editor.on('click', '.add-metric', () => {
                    const metrics = this.getValueForEdit() || [];
                    metrics.push({
                        function: 'Count',
                        datasetIndex: 0,
                        columnId: undefined,
                        alias: ''
                    });
                    this.setValue(metrics);
                });
            }
            destroy() {
                this.metricEditors.forEach(e => e.destroy());
                this.metricEditors = [];
                super.destroy();
            }
        }
        class ColumnSelectorEditor extends DataQueryEditorBase {
            init() {
                var _a, _b;
                this.$column = this.$editor.find('.column-selector');
                this.$aliasContainer = this.$editor.find('.alias-container');
                this.$aliasInput = this.$editor.find('.alias-input');
                this.$timeGrainContainer = this.$editor.find('.time-grain-container');
                this.$timeGrainSelect = this.$editor.find('.time-grain-select');
                this.allowAlias = (_b = (_a = this.propDef.config) === null || _a === void 0 ? void 0 : _a.allowAlias) !== null && _b !== void 0 ? _b : false;
                this.datasets = dashboards.designer.getDatasets();
            }
            update() {
                const dataQuery = this.getDataQuery();
                const datasetRefs = dashboards.getDatasetRefsInDataQuery(dataQuery);
                const currentValue = this.getValue();
                const selectedValue = appn.utils.hasValue(currentValue === null || currentValue === void 0 ? void 0 : currentValue.datasetIndex) && (currentValue === null || currentValue === void 0 ? void 0 : currentValue.columnId) ? `${currentValue.datasetIndex}|${currentValue.columnId}` : '';
                const allowedTypes = (this.propDef.config && this.propDef.config.allowedTypes)
                    ? this.propDef.config.allowedTypes
                    : null;
                dashboards.populatePrefixedColumnSelect(this.$column, datasetRefs, allowedTypes, selectedValue);
                this.$aliasContainer.toggle(this.allowAlias && !!(currentValue === null || currentValue === void 0 ? void 0 : currentValue.columnId));
                this.$aliasInput.val((currentValue === null || currentValue === void 0 ? void 0 : currentValue.alias) || '');
                this.$aliasInput.attr('placeholder', 'Alias (Optional)');
                let showTimeGrain = false;
                if ((currentValue === null || currentValue === void 0 ? void 0 : currentValue.columnId) && appn.utils.hasValue(currentValue.datasetIndex)) {
                    const { columnMeta } = dashboards.getContextualColumnMeta(currentValue.datasetIndex, currentValue.columnId, datasetRefs, this.datasets);
                    if (columnMeta && (columnMeta.type === 'Date'))
                        showTimeGrain = true;
                    if (appn.utils.hasValue(currentValue === null || currentValue === void 0 ? void 0 : currentValue.timeGrain) && !showTimeGrain) {
                        this.setTimeGrain(undefined);
                        return;
                    }
                    if (showTimeGrain && !appn.utils.hasValue(currentValue === null || currentValue === void 0 ? void 0 : currentValue.timeGrain)) {
                        this.setTimeGrain(dashboards.InsightTimeGrain.Week);
                        return;
                    }
                }
                this.$timeGrainContainer.toggle(showTimeGrain);
                this.$timeGrainSelect.val((currentValue === null || currentValue === void 0 ? void 0 : currentValue.timeGrain) || appn.emptyString).trigger('change.select2');
                appn.select.initForDesign({
                    elements: this.$editor.find('select'),
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
            }
            setTimeGrain(timeGrain) {
                const colIdentifier = this.getValueForEdit();
                if (!colIdentifier)
                    return;
                colIdentifier.timeGrain = timeGrain;
                this.setValue(colIdentifier);
            }
            bindEvents() {
                this.subscribeToEvent(dashboards.DASH_EVENTS.ALIAS_CHANGED, (payload) => {
                    if (payload.componentId === this.component.id)
                        this.update();
                });
                this.$editor.on('change', '.column-selector', (e) => {
                    const val = $(e.target).val();
                    if (val) {
                        const colIdentifier = this.getValueForEdit() || {};
                        const [datasetIndexStr, columnId] = val.split('|');
                        const datasetIndex = parseInt(datasetIndexStr, 10);
                        colIdentifier.datasetIndex = datasetIndex;
                        colIdentifier.columnId = columnId;
                        const dataQuery = this.getDataQuery();
                        const datasetRefs = dashboards.getDatasetRefsInDataQuery(dataQuery);
                        const { columnMeta } = dashboards.getContextualColumnMeta(datasetIndex, columnId, datasetRefs, this.datasets);
                        const isDate = columnMeta && (columnMeta.type === 'Date');
                        colIdentifier.timeGrain = isDate ? ((colIdentifier === null || colIdentifier === void 0 ? void 0 : colIdentifier.timeGrain) || dashboards.InsightTimeGrain.Week) : undefined;
                        this.setValue(colIdentifier);
                    }
                    else
                        this.setValue(null);
                });
                this.$editor.on('change', '.time-grain-select', (e) => {
                    this.setTimeGrain($(e.target).val() || undefined);
                });
                this.$editor.on('input', '.alias-input', (e) => {
                    const currentValue = this.getValueForEdit();
                    if (currentValue) {
                        const oldAlias = currentValue.alias;
                        const newAlias = $(e.target).val();
                        currentValue.alias = newAlias;
                        this.setValue(currentValue);
                        if (oldAlias !== newAlias) {
                            distill.eventBus.publish(dashboards.DASH_EVENTS.ALIAS_CHANGED, {
                                componentId: this.component.id,
                                oldAlias: oldAlias,
                                newAlias: newAlias
                            });
                        }
                    }
                });
                this.$editor.on('change', '.alias-input', (e) => {
                    const currentValue = this.getValueForEdit();
                    if (!currentValue)
                        return;
                    const oldAlias = currentValue.alias;
                    const newAlias = $(e.target).val();
                    const rootDataQuery = this.getDataQuery();
                    currentValue.alias = dashboards.runAggregationAliasDeduplication(rootDataQuery, newAlias, this.propDef.path || '');
                    this.setValue(currentValue);
                    if (oldAlias !== currentValue.alias) {
                        distill.eventBus.publish(dashboards.DASH_EVENTS.ALIAS_CHANGED, {
                            componentId: this.component.id,
                            oldAlias: oldAlias,
                            newAlias: currentValue.alias
                        });
                    }
                });
            }
        }
        class BreakDownByLimitEditor extends DataQueryEditorBase {
            init() {
                this.$valueContainer = this.$editor.find('.breakdown-limit-value-container');
                this.$metricContainer = this.$editor.find('.breakdown-limit-metric-container');
                this.$type = this.$editor.find('.breakdown-limit-type');
                this.$value = this.$editor.find('.breakdown-limit-value');
                this.$metric = this.$editor.find('.breakdown-limit-metric');
            }
            update() {
                var _a, _b, _c, _d, _e;
                const limit = this.getValue();
                const metrics = ((_a = this.getDataQuery().aggregation) === null || _a === void 0 ? void 0 : _a.metrics) || [];
                const dataQuery = this.getDataQuery();
                const aggregation = dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.aggregation;
                const datasetRefs = dashboards.getDatasetRefsInDataQuery(dataQuery);
                const datasets = dashboards.designer.getDatasets();
                const currentType = (_b = limit === null || limit === void 0 ? void 0 : limit.type) !== null && _b !== void 0 ? _b : 'None';
                const isNone = currentType === 'None';
                this.$type.val(currentType);
                this.$value.val((_c = limit === null || limit === void 0 ? void 0 : limit.limit) !== null && _c !== void 0 ? _c : '');
                this.$metric.empty().append('<option value="">Select metric...</option>');
                metrics.forEach((m, index) => {
                    const text = dashboards.getMetricDisplayText(m, index, aggregation, datasetRefs, datasets);
                    this.$metric.append($('<option>').val(index).text(text));
                });
                this.$metric.val((_e = (_d = limit === null || limit === void 0 ? void 0 : limit.metricIndex) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '');
                this.$valueContainer.toggle(!isNone);
                this.$metricContainer.toggle(!isNone);
                appn.select.initForDesign({
                    elements: this.$editor.find('select'),
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
            }
            bindEvents() {
                this.subscribeToEvent(dashboards.DASH_EVENTS.ALIAS_CHANGED, (payload) => {
                    if (payload.componentId === this.component.id)
                        this.update();
                });
                this.subscribeToEvent(dashboards.DASH_EVENTS.METRIC_REMOVED, (payload) => {
                    if (payload.componentId !== this.component.id)
                        return;
                    const limit = this.getValueForEdit();
                    if (!limit || !appn.utils.hasValue(limit.metricIndex))
                        return;
                    const refIndex = limit.metricIndex;
                    const removedIndex = payload.removedIndex;
                    if (refIndex === removedIndex) {
                        limit.metricIndex = undefined;
                        this.setValue(limit);
                    }
                    else if (refIndex > removedIndex) {
                        limit.metricIndex--;
                        this.setValue(limit);
                    }
                });
                this.$editor.on('change input', '.breakdown-limit-type, .breakdown-limit-value, .breakdown-limit-metric', () => {
                    const type = this.$type.val();
                    if (type === 'None') {
                        this.$valueContainer.hide();
                        this.$metricContainer.hide();
                        this.setValue(undefined);
                        return;
                    }
                    this.$valueContainer.show();
                    this.$metricContainer.show();
                    const newLimit = {
                        type: type,
                        limit: undefined,
                        metricIndex: undefined
                    };
                    const valStr = this.$value.val();
                    newLimit.limit = valStr ? parseInt(valStr, 10) : undefined;
                    const metricIndexStr = this.$metric.val();
                    newLimit.metricIndex = metricIndexStr ? parseInt(metricIndexStr, 10) : undefined;
                    this.setValue(newLimit);
                });
            }
        }
        class SortOrderRowEditor {
            constructor(container, sortOrder, projection, aggregation, datasetRefs, usedColumns, onChanged, onDelete) {
                this.$sortOrderRow = appn.utils.cloneTemplate('editor-sortOrderRow');
                container.append(this.$sortOrderRow);
                this.sortOrder = sortOrder;
                this.projection = projection;
                this.aggregation = aggregation;
                this.datasetRefs = datasetRefs;
                this.usedColumns = usedColumns;
                this.onChanged = onChanged;
                this.onDelete = onDelete;
                this.$column = this.$sortOrderRow.find('.sort-column-select');
                this.$direction = this.$sortOrderRow.find('.sort-direction-select');
                this.update(sortOrder, projection, aggregation, datasetRefs, usedColumns);
                this.bindEvents();
            }
            update(sortOrder, projection, aggregation, datasetRefs, usedColumns) {
                this.sortOrder = sortOrder;
                this.projection = projection;
                this.aggregation = aggregation;
                this.datasetRefs = datasetRefs;
                this.usedColumns = usedColumns;
                this.$direction.val(this.sortOrder.type);
                const selectedValue = (appn.utils.hasValue(this.sortOrder.metricIndex) ? `metric|${this.sortOrder.metricIndex}` : null)
                    || (this.sortOrder.column && appn.utils.hasValue(this.sortOrder.column.datasetIndex) ? `col|${this.sortOrder.column.datasetIndex}|${this.sortOrder.column.columnId}` : '');
                this.populateSortableColumnSelect(this.$column, selectedValue);
            }
            bindEvents() {
                this.$sortOrderRow.on('click', '.remove-sort-order', () => this.onDelete());
                this.$sortOrderRow.on('change', '.sort-direction-select', e => this.onChanged(Object.assign(Object.assign({}, this.sortOrder), { type: $(e.target).val() })));
                this.$sortOrderRow.on('change', '.sort-column-select', e => {
                    const newSortOrder = { type: this.sortOrder.type, column: undefined, metricIndex: undefined };
                    const val = $(e.target).val();
                    if (!val) {
                        this.onChanged(newSortOrder);
                        return;
                    }
                    const parts = val.split('|');
                    if (parts[0] === 'metric')
                        newSortOrder.metricIndex = parseInt(parts[1], 10);
                    else if (parts[0] === 'col')
                        newSortOrder.column = { datasetIndex: parseInt(parts[1], 10), columnId: parts[2] };
                    this.onChanged(newSortOrder);
                });
            }
            populateSortableColumnSelect($select, selectedValue) {
                var _a;
                $select.empty().append('<option value="">Choose...</option>');
                const currentValue = (appn.utils.hasValue(this.sortOrder.metricIndex) ? `metric|${this.sortOrder.metricIndex}` : null)
                    || (this.sortOrder.column && appn.utils.hasValue(this.sortOrder.column.datasetIndex) ? `col|${this.sortOrder.column.datasetIndex}|${this.sortOrder.column.columnId}` : '');
                const datasets = dashboards.designer.getDatasets();
                const createAndAppendOptgroup = (label, options) => {
                    const optgroup = $(`<optgroup label="${label}"></optgroup>`);
                    let hasOptions = false;
                    options.forEach(opt => {
                        if (opt && opt.value) {
                            if (opt.value === currentValue || !this.usedColumns.has(opt.value)) {
                                optgroup.append($('<option>').val(opt.value).text(opt.text));
                                hasOptions = true;
                            }
                        }
                    });
                    if (hasOptions)
                        $select.append(optgroup);
                };
                if (this.projection) {
                    createAndAppendOptgroup("Columns", this.projection.columns.map(p => {
                        const { columnMeta: column } = dashboards.getContextualColumnMeta(p.datasetIndex, p.columnId, this.datasetRefs, datasets);
                        if (!column)
                            return null;
                        const text = p.alias || dashboards.getColumnOptionText(column);
                        const value = `col|${p.datasetIndex}|${p.columnId}`;
                        return { value, text };
                    }));
                }
                else if (this.aggregation) {
                    const groups = [this.aggregation.groupBy, this.aggregation.breakDownBy].filter(g => g === null || g === void 0 ? void 0 : g.columnId);
                    if (groups.length > 0) {
                        const showPrefix = this.datasetRefs.length > 1;
                        createAndAppendOptgroup("Groups", groups.map(g => {
                            const { datasetRef, dataset, columnMeta: column } = dashboards.getContextualColumnMeta(g.datasetIndex, g.columnId, this.datasetRefs, datasets);
                            if (!datasetRef || !dataset || !column)
                                return null;
                            const datasetPrefix = datasetRef.alias || dataset.name;
                            const columnText = dashboards.getColumnOptionText(column);
                            const text = showPrefix ? `${datasetPrefix}.${columnText}` : columnText;
                            const value = `col|${g.datasetIndex}|${g.columnId}`;
                            return { value: value, text: text };
                        }));
                    }
                    if (((_a = this.aggregation.metrics) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        createAndAppendOptgroup("Metrics", this.aggregation.metrics.map((m, index) => {
                            const value = `metric|${index}`;
                            const text = dashboards.getMetricDisplayText(m, index, this.aggregation, this.datasetRefs, datasets);
                            return { value, text };
                        }));
                    }
                }
                if (selectedValue)
                    $select.val(selectedValue);
            }
            destroy() {
                this.$sortOrderRow.remove();
            }
        }
        class SortOrderEditor extends DataQueryEditorBase {
            constructor() {
                super(...arguments);
                this.sortOrderEditors = [];
            }
            init() {
                this.$sortOrdersList = this.$editor.find('.sort-orders-list');
                this.$addSortOrder = this.$editor.find('.add-sort-order');
            }
            update() {
                var _a;
                const sortOrders = this.getValue() || [];
                const dataQuery = this.getDataQuery();
                const datasetRefs = dashboards.getDatasetRefsInDataQuery(dataQuery);
                const usedColumns = new Set((sortOrders).map(so => (appn.utils.hasValue(so.metricIndex) ? `metric|${so.metricIndex}` : null)
                    || (so.column && appn.utils.hasValue(so.column.datasetIndex) ? `col|${so.column.datasetIndex}|${so.column.columnId}` : undefined)));
                const getSortableOptions = () => {
                    var _a;
                    const options = [];
                    if (dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.projection) {
                        dataQuery.projection.columns.forEach(p => {
                            const value = `col|${p.datasetIndex}|${p.columnId}`;
                            if (appn.utils.hasValue(p.datasetIndex) && p.columnId)
                                options.push(value);
                        });
                    }
                    else if (dataQuery === null || dataQuery === void 0 ? void 0 : dataQuery.aggregation) {
                        const groups = [dataQuery.aggregation.groupBy, dataQuery.aggregation.breakDownBy]
                            .filter(g => g === null || g === void 0 ? void 0 : g.columnId);
                        groups.forEach(g => {
                            if (appn.utils.hasValue(g.datasetIndex) && g.columnId)
                                options.push(`col|${g.datasetIndex}|${g.columnId}`);
                        });
                        (_a = dataQuery.aggregation.metrics) === null || _a === void 0 ? void 0 : _a.forEach((m, index) => {
                            options.push(`metric|${index}`);
                        });
                    }
                    return options;
                };
                const allSortableOptions = getSortableOptions();
                this.$addSortOrder.toggle(allSortableOptions.length > sortOrders.length);
                while (this.sortOrderEditors.length > sortOrders.length)
                    (_a = this.sortOrderEditors.pop()) === null || _a === void 0 ? void 0 : _a.destroy();
                sortOrders.forEach((sortOrder, index) => {
                    if (this.sortOrderEditors.length <= index) {
                        const onChange = (newSortData) => {
                            const currentSorts = this.getValueForEdit() || [];
                            currentSorts[index] = newSortData;
                            this.setValue(currentSorts);
                        };
                        const onDelete = () => {
                            const currentSorts = this.getValueForEdit() || [];
                            currentSorts.splice(index, 1);
                            this.setValue(currentSorts);
                        };
                        const editor = new SortOrderRowEditor(this.$sortOrdersList, sortOrder, dataQuery.projection, dataQuery.aggregation, datasetRefs, usedColumns, onChange, onDelete);
                        this.sortOrderEditors.push(editor);
                    }
                    else
                        this.sortOrderEditors[index].update(sortOrder, dataQuery.projection, dataQuery.aggregation, datasetRefs, usedColumns);
                });
                appn.select.initForDesign({
                    elements: this.$editor.find('select'),
                    omitWidth: true,
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
            }
            bindEvents() {
                this.subscribeToEvent(dashboards.DASH_EVENTS.ALIAS_CHANGED, (payload) => {
                    if (payload.componentId === this.component.id)
                        this.update();
                });
                this.subscribeToEvent(dashboards.DASH_EVENTS.METRIC_REMOVED, (payload) => {
                    if (payload.componentId !== this.component.id)
                        return;
                    const sortOrders = this.getValueForEdit() || [];
                    if (sortOrders.length === 0)
                        return;
                    const removedIndex = payload.removedIndex;
                    let wasChanged = false;
                    sortOrders.forEach(so => {
                        const refIndex = so.metricIndex;
                        if (appn.utils.hasValue(refIndex)) {
                            if (refIndex === removedIndex) {
                                so.metricIndex = undefined;
                                wasChanged = true;
                            }
                            else if (refIndex > removedIndex) {
                                so.metricIndex--;
                                wasChanged = true;
                            }
                        }
                    });
                    if (wasChanged)
                        this.setValue(sortOrders);
                });
                this.$editor.on('click', '.add-sort-order', () => {
                    const sortOrders = this.getValueForEdit() || [];
                    sortOrders.push({ type: 'Asc' });
                    this.setValue(sortOrders);
                });
            }
            destroy() {
                this.sortOrderEditors.forEach(e => e.destroy());
                this.sortOrderEditors = [];
                super.destroy();
            }
        }
        class ReferenceLineRowEditor {
            constructor(container, data, onChange, onDelete) {
                this.$row = appn.utils.cloneTemplate('editor-referenceLineRow');
                container.append(this.$row);
                this.data = data;
                this.onChange = onChange;
                this.onDelete = onDelete;
                this.$label = this.$row.find('.ref-label');
                this.$type = this.$row.find('.ref-type');
                this.$value = this.$row.find('.ref-value');
                this.$valuePlaceholder = this.$row.find('.ref-value-placeholder');
                this.$color = this.$row.find('.ref-color');
                this.$style = this.$row.find('.ref-style');
                this.$removeBtn = this.$row.find('.remove-ref');
                appn.select.initForDesign({ elements: this.$row.find('select') });
                this.$color.minicolors(new appn.minicolors.Options());
                this.update(data);
                this.bindEvents();
            }
            update(data) {
                var _a, _b;
                this.data = data;
                if (this.$label.val() !== (this.data.label || ''))
                    this.$label.val(this.data.label || '');
                if (this.$type.val() !== (this.data.type || 'Constant'))
                    this.$type.val(this.data.type || 'Constant').trigger('change.select2');
                if (this.$style.val() !== (this.data.lineStyle || 'dashed'))
                    this.$style.val(this.data.lineStyle || 'dashed').trigger('change.select2');
                if (this.$value.val() !== (((_a = this.data.value) === null || _a === void 0 ? void 0 : _a.toString()) || ''))
                    this.$value.val((_b = this.data.value) !== null && _b !== void 0 ? _b : '');
                this.$color.minicolors('value', this.data.color || '#000000');
                if (this.data.type === 'Constant') {
                    this.$value.show();
                    this.$valuePlaceholder.hide();
                }
                else {
                    this.$value.hide();
                    this.$valuePlaceholder.show();
                }
            }
            bindEvents() {
                this.$removeBtn.on('click', () => this.onDelete());
                this.$label.on('input', e => {
                    this.data.label = $(e.target).val();
                    this.onChange(this.data);
                });
                this.$value.on('input', e => {
                    const valStr = $(e.target).val();
                    this.data.value = valStr === '' ? undefined : parseFloat(valStr);
                    this.onChange(this.data);
                });
                this.$type.on('change', e => {
                    this.data.type = $(e.target).val();
                    this.update(this.data);
                    this.onChange(this.data);
                });
                this.$style.on('change', e => {
                    this.data.lineStyle = $(e.target).val();
                    this.onChange(this.data);
                });
                this.$color.on('change', e => {
                    this.data.color = $(e.target).val();
                    this.onChange(this.data);
                });
            }
            destroy() {
                this.$row.remove();
            }
        }
        class ReferenceLinesEditor extends DataQueryEditorBase {
            constructor() {
                super(...arguments);
                this.rowEditors = [];
            }
            init() {
                this.$list = this.$editor.find('.ref-lines-list');
                this.$addBtn = this.$editor.find('.add-ref-line');
            }
            update() {
                var _a;
                const lines = this.getValue() || [];
                while (this.rowEditors.length > lines.length)
                    (_a = this.rowEditors.pop()) === null || _a === void 0 ? void 0 : _a.destroy();
                lines.forEach((line, index) => {
                    if (this.rowEditors.length <= index) {
                        const onChange = (newData) => {
                            const current = this.getValueForEdit() || [];
                            current[index] = newData;
                            this.setValue(current);
                        };
                        const onDelete = () => {
                            const current = this.getValueForEdit() || [];
                            current.splice(index, 1);
                            this.setValue(current);
                        };
                        const editor = new ReferenceLineRowEditor(this.$list, line, onChange, onDelete);
                        this.rowEditors.push(editor);
                    }
                    else
                        this.rowEditors[index].update(line);
                });
            }
            bindEvents() {
                this.$addBtn.on('click', () => {
                    const current = this.getValueForEdit() || [];
                    current.push({
                        type: 'Constant',
                        color: '#ff0000',
                        value: undefined,
                        label: 'Ref Line',
                        lineStyle: 'dashed'
                    });
                    this.setValue(current);
                });
            }
            destroy() {
                this.rowEditors.forEach(r => r.destroy());
                this.rowEditors = [];
                super.destroy();
            }
        }
        class ScopeItemRowEditor {
            constructor(container, scopeItem, availableItems, usedIds, onChanged, onDelete) {
                this.$row = appn.utils.cloneTemplate('editor-scopeItemRow');
                container.append(this.$row);
                this.scopeItem = scopeItem;
                this.availableItems = availableItems;
                this.usedIds = usedIds;
                this.onChanged = onChanged;
                this.onDelete = onDelete;
                this.$itemSelect = this.$row.find('.scope-item-select');
                this.$recursiveCheckbox = this.$row.find('.scope-recursive-checkbox');
                this.$deleteBtn = this.$row.find('.remove-scope-item');
                this.update(scopeItem, availableItems, usedIds);
                this.bindEvents();
            }
            update(scopeItem, availableItems, usedIds) {
                this.scopeItem = scopeItem;
                this.availableItems = availableItems;
                this.usedIds = usedIds;
                this.$itemSelect.val(scopeItem.id);
                const selectedItem = availableItems.find(i => i.value === scopeItem.id);
                const isFolder = selectedItem && !selectedItem.isArtifact;
                this.$recursiveCheckbox.prop('checked', scopeItem.recursive || false);
                this.$recursiveCheckbox.prop('disabled', !isFolder);
                if (!isFolder) {
                    this.$recursiveCheckbox.closest('div').hide();
                }
                else {
                    this.$recursiveCheckbox.closest('div').show();
                }
                this.populateItemSelect(availableItems, usedIds);
            }
            populateItemSelect(availableItems, usedIds) {
                this.$itemSelect.empty().append('<option value="">Choose...</option>');
                const folders = availableItems.filter(i => !i.isArtifact);
                const docs = availableItems.filter(i => i.isArtifact);
                if (folders.length > 0) {
                    const $folderGroup = $('<optgroup label="Folders"></optgroup>');
                    folders.forEach(item => {
                        if (item.value === this.scopeItem.id || !usedIds.has(item.value)) {
                            $folderGroup.append($('<option>').val(item.value).text(item.text));
                        }
                    });
                    this.$itemSelect.append($folderGroup);
                }
                if (docs.length > 0) {
                    const $docGroup = $('<optgroup label="Artifacts"></optgroup>');
                    docs.forEach(item => {
                        if (item.value === this.scopeItem.id || !usedIds.has(item.value)) {
                            $docGroup.append($('<option>').val(item.value).text(item.text));
                        }
                    });
                    this.$itemSelect.append($docGroup);
                }
                this.$itemSelect.val(this.scopeItem.id);
            }
            bindEvents() {
                this.$deleteBtn.on('click', () => this.onDelete());
                this.$itemSelect.on('change', e => {
                    const newId = $(e.target).val();
                    const selectedItem = this.availableItems.find(i => i.value === newId);
                    const isFolder = selectedItem && !selectedItem.isArtifact;
                    this.onChanged(Object.assign(Object.assign({}, this.scopeItem), { id: newId, recursive: isFolder ? this.scopeItem.recursive : false }));
                });
                this.$recursiveCheckbox.on('change', e => {
                    this.onChanged(Object.assign(Object.assign({}, this.scopeItem), { recursive: $(e.target).prop('checked') }));
                });
            }
            destroy() {
                this.$row.remove();
            }
        }
        class ScopeItemsEditor extends distill.EditorBase {
            constructor() {
                super(...arguments);
                this.scopeItemEditors = [];
            }
            init() {
                this.$scopeItemsList = this.$editor.find('.scope-items-list');
                this.$addScopeItem = this.$editor.find('.add-scope-item');
            }
            update() {
                var _a;
                const scopeItems = this.getValue() || [];
                const availableItems = dashboards.designer.getItemList();
                const usedIds = new Set(scopeItems.map(si => si.id));
                this.$addScopeItem.toggle(availableItems.length > scopeItems.length);
                while (this.scopeItemEditors.length > scopeItems.length)
                    (_a = this.scopeItemEditors.pop()) === null || _a === void 0 ? void 0 : _a.destroy();
                scopeItems.forEach((scopeItem, index) => {
                    if (this.scopeItemEditors.length <= index) {
                        const onChange = (newItem) => {
                            const currentItems = this.getValueForEdit() || [];
                            currentItems[index] = newItem;
                            this.setValue(currentItems);
                        };
                        const onDelete = () => {
                            const currentItems = this.getValueForEdit() || [];
                            currentItems.splice(index, 1);
                            this.setValue(currentItems);
                        };
                        const editor = new ScopeItemRowEditor(this.$scopeItemsList, scopeItem, availableItems, usedIds, onChange, onDelete);
                        this.scopeItemEditors.push(editor);
                    }
                    else {
                        this.scopeItemEditors[index].update(scopeItem, availableItems, usedIds);
                    }
                });
                appn.select.initForDesign({
                    elements: this.$editor.find('select'),
                    omitWidth: true,
                    minimumResultsForSearch: MIN_RESULTS_FOR_SEARCH
                });
            }
            bindEvents() {
                this.$addScopeItem.on('click', () => {
                    const availableItems = dashboards.designer.getItemList();
                    const currentItems = this.getValueForEdit() || [];
                    const usedIds = new Set(currentItems.map(si => si.id));
                    const available = availableItems.find(item => !usedIds.has(item.value));
                    if (!available)
                        return;
                    const newItem = {
                        id: available.value,
                        recursive: false
                    };
                    this.setValue([...currentItems, newItem]);
                });
            }
            destroy() {
                this.scopeItemEditors.forEach(e => e.destroy());
                this.scopeItemEditors = [];
                super.destroy();
            }
        }
        distill.editors.register('datasetSelector', DatasetSelectorEditor);
        distill.editors.register('filtersEditor', FiltersEditor);
        distill.editors.register('projectionSelector', ProjectionSelectorEditor);
        distill.editors.register('metricsEditor', MetricsEditor);
        distill.editors.register('columnSelector', ColumnSelectorEditor);
        distill.editors.register('breakDownByLimitEditor', BreakDownByLimitEditor);
        distill.editors.register('sortOrderEditor', SortOrderEditor);
        distill.editors.register('aggregationFiltersEditor', AggregationFiltersEditor);
        distill.editors.register('referenceLinesEditor', ReferenceLinesEditor);
        distill.editors.register('scopeItemsEditor', ScopeItemsEditor);
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
